import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { Component, ViewChild, OnInit, Inject, ElementRef, ViewChildren, QueryList, HostListener } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { of as observableOf, Observable, of, Subscription, throwError } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { files } from '../../_models/example-data';
import { ProjectService } from '../../_services/project.service';
import { TestService } from '../../_services/test.service';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, find, switchMap } from 'rxjs/operators';
import { UserMgmtService } from '../../_services/user-mgmt.service';
import { UserService } from '../../_services/user.service';
import { UrlService } from '../../_services/url.service';
import { UserRestrictions } from '../../_models/userRestriction';
import { UserTab } from '../../_models/UserTab';
import { ProjectData } from 'src/app/_models/project-data';
import { Pipe, PipeTransform } from '@angular/core';
import { jsPlumb } from 'jsplumb';
import * as _ from "lodash";
import html2canvas from 'html2canvas';
import $ from 'jquery';
// import { MatDialog, MatSidenav, MatTableDataSource } from '@angular/material';
import { SpecialPipe } from '../../specialPipe';

import { TreelistService } from './treelist.service';
import { ResourceLoader } from '@angular/compiler';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog.service';
import { Location } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { template } from 'lodash';
import { MatMenuTrigger } from '@angular/material/menu';
import { environment } from 'src/environments/environment';
import { SettingService } from 'src/app/_services/setting.service';
import 'bootstrap';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { MemoryService } from 'src/app/_services/memory.service';
// import { DndDropEvent } from 'ngx-drag-drop';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { isObject } from 'util';
import { SpinnerService } from 'src/app/_services/spinner.service';
import { HomeService } from "src/app/_services/home.service";

@Component({
  selector: 'app-test-step',
  templateUrl: './test-step.component.html',
  styleUrls: ['./test-step.component.scss']
})

export class TestStepComponent implements OnInit {
  // dataSource = new MatTableDataSource<Element>(this.testStepdata.teststepList);
  selection = new SelectionModel<Element>(true, []);
  public treeLists = [];
  public currentlySelectedTree;
  public currentlySelectedTreeId;
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  @ViewChild('closeMoveModal', null) closeMoveModal: ElementRef;
  @ViewChild('cancelmodalforcomment', null) cancelmodalforcomment: ElementRef;
  @ViewChild('mySideNav', { static: true }) public myNav: MatSidenav;
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  @ViewChild('selectAllBox', null) selectAllBox: ElementRef;
  @ViewChild('canvasContent', null) canvasContent: ElementRef;
  @ViewChild('closeContext', null) closeContext: ElementRef;
  @ViewChild("cancelAddLocator") cancelAddLocator: ElementRef;
  @ViewChild("cancelUpdateLocator") cancelUpdateLocator: ElementRef;
  @ViewChild("selectBox") selectBox: ElementRef;
  @ViewChild('testStepUpdateForm') testStepUpdateForm: NgForm;
  @ViewChild("stepTab") stepTab: ElementRef;
  headerOptions = {
    showSetting: true,
    showSearch: false,
    heading: 'Step',
    data: undefined,
  }
  title = 'FlowChart Integration';
  nodes = [{ id: 'Node0', name: 'Start', type: '', Action: '', Screen: '', Parameter: '', Element: '' }];
  index = 0;
  hide = false;
  projectId: any;
  testId: any; testStepId: any;
  url: any;
  testCaseData: any;
  testCaseIds: any;
  testStepdata: any;
  testStep: any;
  testStepdataCopy:any;
  logEntry: any;
  functionData: any;
  testStepNodeData: any;
  dummyData: ({ name?: undefined; id?: undefined; showchildren?: undefined; children?: undefined; } | { name: string; id: string; showchildren: string; children: { name: string; id: string; showchildren: string; children: { name: string; id: string; showchildren: string; children: { name: string; id: string; showchildren: string; children: any[]; }[]; }[]; }[]; })[];
  stepsTobeDelete: any;
  Index: any;
  initiateDelTestStep: any;
  testStepAtSelectedIndex: any;
  router: string;
  checkExtension = 0;
  preItem: any[];
  manageParamOptions = ["Text", "Global Variable", "Function"];
  locatorData: any;
  value: any;
  selectedValue: any;
  selectedfValue: any;
  functions = [] as any;
  actions = [] as any;
  fieldlist: any;
  methodname: any;
  defaultValues: [];
  StepMoveEnable: boolean;
  getProjectByIdData: Object;
  globalVariable: any;
  selectedFunctionValues: any;
  selectedGvar: any;
  invokeStep = false;
  stepIndex: number;

  arr: any;
  testStepIndex: any;
  selectedAction: any;
  selectedScreen: any;
  elementKeyData: any;
  elementEntryKeyData: any;
  visibleFieldValue: any;
  Vfeild: any[];
  showFormUpdateFlag = false;
  projectData: any;
  selectedIndexOnClick: any[];
  form: UntypedFormGroup;
  testStepArrayForDel: [
    {},
  ];
  myVar1: boolean = false;
  indexFormArray: UntypedFormArray;
  testStep1: any;
  setTypeManual: any;
  moduleName: any;
  MyArray: any;
  projectType: any;
  testDataForManangeLocator: any;
  moveIndex: any;
  submitted: boolean;
  moveTestStepForm: UntypedFormGroup;
  orderIndex: any;
  sourceIndex: any;
  agentCheck: boolean;
  tabList = [];
  stepIndexForInsertComment: any;
  formObj: any;
  valueForInsert: any;
  valueForUpdate = '';
  enableBUtton: boolean = true;
  testStepIndexForInsert: any;
  enableCopy: boolean = false;
  enablePaste: boolean = false;
  testStepArray: { id: any; teststepList: any[]; };
  enableCopyCheck: boolean;
  cutTestStepArray: { list: any[]; };
  enableCutPaste: boolean = false;
  enableCut: boolean;
  editStep: boolean = false;
  selectedPage: any;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedTestStep = undefined;
  parameterForInvokeTest = [];
  idsList: any;
  indexArray: any[];
  allTestCaseData: any;
  filterStepDataForParam: any;
  testStepCopy: any;
  disableNextBUtton: boolean = true;
  disablePreviosBUtton: boolean = true;
  projectName: any;
  typeCheck: any;
  eventData: any;
  createCopy: any;
  isRecording: true;
  testCassedata: {};
  testCaseStep: any;
  ScreenNameForHighLight: any = [];
  allBoxChecked: boolean = false;
  testIdForRecoder: string;
  testCaseType: any;
  checked_true: boolean;
  checked_master: boolean;
  functionInfo: any = {};
  testData: any = []
  checkAllTestSteps: boolean = false;
  testStepInfo: any;
  highlite: any;
  commandDesc: any = '';
  cardView: boolean;
  expandedView: boolean = false;
  collapseAllCard: boolean = false;
  visibleIndex: any = [];
  visibleIndexForToolTip: any;
  openToolTipIndex: boolean = false;
  commandName: any;
  groupedActionData: any;
  clubbedActions: any;
  subFunctionsCollections: any = [];
  showSubFunctionFlag: boolean = false;
  droppedStep: any;
  subFunctionType: any;
  FunctionName: any;
  subFunctionObject: string;
  groupNameDis: any;
  urlName: any;
  hideCardIndex: boolean = false;
  visibleIndexForCardTip: any;
  ActionName: any;
  actionType: string;
  globalSearch: any = [];
  showSuggestion: boolean = false;
  matchedSuggestions: any = [];
  searchSuggestions: any = [];
  groupedActionDataCopy: any;
  groupedActionDataCopy1: any;
  actionsMetaData: any = {};
  colors: string[];
  actionsFilter: any;
  loadTestStepData: boolean = false;
  cardViewType: string = 'Vertical';
  moduleId: string;
  projectSubscription: Subscription;
  menuMobileShown: boolean = false;
  menuDesktopHidden: boolean = false;
  stepIndexTobeEdit: number = undefined;
  enableEdit: boolean = false;
  objectForEditTestStep: any;
  rawclicked: boolean = true;
  formclicked: boolean = false;
  locatorId: any;
  selectedKeys: any[];
  valuechanged: boolean;
  currentFunction: any;
  parameterValueForUpdate: any;
  eventwithoutSpace: any;
  enableTextField: boolean = false;
  optionSelected = [];
  textParameter: any;
  functionDataForUpdate: any;
  performedAction: string = 'Edit';
  locatorManagementCheck: boolean = false;
  addScreenCheck: boolean = true;
  addLocatorsForm: UntypedFormGroup;
  updateLocatorsForm: UntypedFormGroup;
  editLocatorTitleForm: UntypedFormGroup;
  locatorEntryMapValue: any;
  locatorValueData: any;
  locatorEntryCommentValue: any;
  keyForinsertComment: any;
  locatorValueIndex: any;
  breadCrumb: any;
  enableEditForm: boolean;
  showDetail: boolean = false;
  detailDesplay: string;
  testCopyFlowChart: any;
  shrinkArray = [];
  showIndex: undefined;
  testCopyFlowChart1: any;
  startIfIndex: any;
  endIndex: any;
  LongArrow: boolean;
  filterAllTesCaseData: any;
  selectedCaseId: string;
  selectedCase: any;
  selectedTestCase: any;
  objectForEditTestStepCopy: any;
  keyForinsertComment1: any;
  valueForInsert1: any;
  valueForUpdate1: any;
  selectedFunction: any;
  actionsMetaDataCopy: any={};
  pseCommand: any;
  checkedIndex: any;
  allBranches: any;
  

  constructor(
    private testCase: TestService,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private http: HttpClient,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private userManagement: UserMgmtService,
    public dialog: MatDialog,
    private _router: Router,
    private location: Location,
    private fb: UntypedFormBuilder,
    private confirmationDialogService: ConfirmationDialogService,
    private treelistsvc: TreelistService,
    private setting: SettingService,
    private urlService: UrlService,
    private spinnerService: SpinnerService,
    private homeService: HomeService,
    private memoryService:MemoryService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.url = environment.baseUrl;
    this.form = this.fb.group({
      checkArray: this.fb.array([])
    })
    this.router = _router.url;
    this.route.queryParamMap.subscribe((data: any) => {
      this.selectedTestStep = data.params.index;
      if (this.selectedTestStep) {
        //  document.getElementById(this.selectedTestStep).scrollIntoView({ behavior: 'smooth' });
        ////"selectedTestStep", this.selectedTestStep);
        // this.reloadComponent();
        setTimeout(() => {

          this.selectedTestStep = undefined;
        }, 5000)
      }


    })

    this.route.paramMap.subscribe(
      params => {
        // this.testIdForRecoder = params.get('tsid');
        this.projectId = params.get('pid');
        this.testId = params.get('tid');
        this.testStepId = params.get('tsid');
        this.headerOptions.data = { projectId: this.projectId };
        //set header details
        this.homeService.setHeaderOptions(this.headerOptions);
        if (this.testStepId.indexOf('?') != -1) {
          var index = this.testStepId.indexOf('?');
          //'search', index);

          this.testStepId = this.testStepId.slice(0, index);
        }

        ////this.testStepId);
        localStorage.setItem('testForRecoder', params.get('tsid'));
        localStorage.setItem('projectIdForRecoder', params.get('pid'));
        localStorage.setItem('taskIdForRecorder', params.get('tid'));


        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {

              this.testStepdata = data;
              this.testStepdataCopy =JSON.parse(JSON.stringify(data));
              
              try {
                localStorage.setItem('testStepdata', JSON.stringify(this.testStepdata));
              } catch (error) {
                console.log('unable to save project data to local');
                
              }
              this.moduleName = this.testStepdata.path;
              this.moduleName = this.moduleName.split(',')
              this.testStep = [];
              this.testStep = this.testStepdata.teststepList;
              this.currentUrl = this._router.url;
              this.urlName = this.testStepdata.title;
              this.previousUrl = this.urlService.captureUrl(this.currentUrl, this.urlName, 'testStep');
              localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
              this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));

              this.testCaseType = this.testStepdata.testCaseType
              ////'testC123',this.testCaseType)
              if(this.testStep==undefined){
                // this.testCase.shareTestSteps(null);
               }
              for (let i = 0; i < this.testStep.length; i++) {
                // this.testStep[i] = {
                //    stepIndex:''
                //   }
                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;

              }
              this.visibleIndexForCardTip = this.testStep.length
              this.loadFlowchart(this.testStep);
            
              //after getting test steps load the branches
              let response = this.testCase.fetchBranches();
              this.testCase.loadBranches.next(response);

              this.loadTestStepData = false;
              // setTimeout(() => {
                this.getIncludedTestCases();
                if (this.testStepCopy.length > 0) {
                  this.objectForEditTestStep = undefined;
                  this.editEnable(this.testStepCopy[0]);
                }
  
              // }, 1000);
              this.getLocator();
             
              let CurrentNode: any = {
                name: '',
                id: Number,
                parameter: '',
                screen: '',
                element: '',
                testStepId: this.testStepdata.id,
                projectid: this.testStepdata.projectId,
                parentId: this.testStepdata.parentTestDataId,
                showChildren: 1,
                item: {},
                type: '',
                children: []
              };
              this.testStepNodeData = CurrentNode;     //{name,Children,showChilder,item,children[]}

              for (let i = 0; i < this.testStep.length; i++) {
                ////'1CurrentNodeData>>')
                CurrentNode.name = this.testStep[i].commandName;
                CurrentNode.id = i + 1;
                CurrentNode.parameter = this.testStep[i].parameters;
                CurrentNode.screen = this.testStep[i].pageName;
                CurrentNode.element = this.testStep[i].elementKey;
                CurrentNode.projectid = this.testStepdata.projectId,
                  CurrentNode.parentId = this.testStepdata.parentTestDataId,
                  CurrentNode.testStepId = this.testStepdata.id,
                  CurrentNode.showChildren = 1;
                CurrentNode.item = this.testStep[i];
                CurrentNode.type = this.testStep[i].type;
                // CurrentNode.item=this.testStep[i];
                CurrentNode.children = [{}];
                CurrentNode = CurrentNode.children[0];          //refrenc

                // if(i== this.testStep.length){
                //   CurrentNode = CurrentNode.children[0];
                //   ////'last Child');
                //   CurrentNode.children='End';
                // }
              }

              ////'CurrentNodeData>>', this.testStepNodeData.children);
              if (this.testStepNodeData.children.length == 0) {
                this.testStepNodeData.children = [];
                ////'IFCurrentNodeData>>', this.testStepNodeData);
              }
              console.log('nestedData', this.testStepNodeData);

              this.testStepNodeData = { name: 'START', children: [this.testStepNodeData] }


              this.treelistsvc.treeToggler$.subscribe((status) => {
                this.currentlySelectedTree = treelistsvc.currentlySelectedTree;
                this.currentlySelectedTreeId = treelistsvc.currentlySelectedTreeId;
                this.treelistsvc.clearHiddenChildren();
              });
              const CurrentChildTestData = [{ name: 'Table-View', children: [] }, this.testStepNodeData];
              ////"dataMatch", CurrentChildTestData);
              for (const c of CurrentChildTestData) {
                ////"CurrentChild>>", this.testStepNodeData.children);
                ////"ChildData>>", CurrentChildTestData)
                const alist = [];
                alist.push(c);
                this.treeLists.push([alist]);

              }
              ////this.treeLists[1]);
              this.treelistsvc.setCurrentlySelectedTree(this.treeLists[1]);
              this.currentlySelectedTree = treelistsvc.currentlySelectedTree;
              this.currentlySelectedTreeId = this.currentlySelectedTree[0][0].id;
              // for (let i = 0; i < Tslength; i++) {
              //   ////'testStep>>',this.testStep[i]);
              //   this.nodes.push({id : 'Node' + (this.index + 1),
              //                    name: 'step >>' + ((this.index + 1)),
              //                    Action: 'Action>>' + (this.testStep[i].commandName),
              //                    Screen: 'PageName>>' + (this.testStep[i].pageName),
              //                    Parameter:'Parameter>>' + (this.testStep[i].parameters),
              //                    Element: 'Element>>' + (this.testStep[i].elementKey),
              //                                 type: '',});
              //   this.index += 1;
              //   }
              // this.addNode(Tslength);
            }
          )

        // this.getGroupedAction();
      }



    );

    $('.hl-btnAction .btn').click(function () {
      $('.hl-chooseCatogeryWrapper').addClass('show');
    });
    $('.hl-topWrapper .hl-rightCol').click(function () {

      $('.hl-actionWrapper').removeClass('show');
    });
    $('#browseevents').click(function () {
      $('.hl-chooseCatogeryWrapper').removeClass('show');
      $('.hl-actionWrapper').addClass('show');
    });
    $('#CatogeryMiddle').click(function () {
      $('.hl-actionWrapper').removeClass('show');

    });
  }

  loadFlowchart(data) {
    this.testStepCopy = JSON.parse(JSON.stringify(data));

    // sharing to flowchart component inorder to convert it
    this.testCase.shareTestSteps(undefined);
    this.attachHitlBrnach();
    // this.testCase.setStepForEdit(undefined)
    try{
      localStorage.setItem('localData',JSON.stringify(data))
    }
    catch{
     this.toastrService.clear();
     this.toastrService.warning('Project size is bigger will take some time to load please wait.')
    }
    
    this.testCopyFlowChart = JSON.parse(JSON.stringify(data));
    this.testCopyFlowChart1 = JSON.parse(JSON.stringify(data));
    console.log('neste', this.testCopyFlowChart1);
    this.checkIfBlock(this.testCopyFlowChart1);
    //   for (let index = 0; index < this.testCopyFlowChart1.length; index++) {
    //     const element = this.testCopyFlowChart1[index];
    //     if(element.commandName == 'IF'){
    //       this.testCopyFlowChart1[index-1].children.push(this.testCopyFlowChart1[index])
    //     }
    //   }
    //  console.log('neste',this.testCopyFlowChart1);

    // var isLoopStarted = false;
    // let ifConditionIndex;
    // let endIfIndex;
    // let  countIf = 0 
    // this.testStepCopy.forEach((element,i) => {
    //   element.viewS=true;
    //   if(element.commandName=='IF' || element.commandName=='FOR'){
    //     ++countIf;
    //     isLoopStarted=true;
    //     ifConditionIndex =  i+1;
    //   }
    //   else if(element.commandName=='ENDIF' || element.commandName=='ENDFOR'){
    //     isLoopStarted=false;
    //     endIfIndex = i + 1;
    //   }
    //   // if(isLoopStarted){
    //   //  element['view']='horizontal'
    //   // }
    //   // else{
    //   //   element['view']='vertical'
    //   // }
    // });

    // let ifChildren = [];
    // let elseChildren = [];
    // console.log("Flowchart :", ifConditionIndex, endIfIndex);
    // ifChildren = this.testCopyFlowChart.slice(ifConditionIndex, endIfIndex);
    // ifChildren.forEach((element)=>
    // {
    //   // if(element.commandName=='ELSEIF' || 'ELSE'){

    //   // }
    //   element['view'] = 'horizontal';
    // })
    // this.testCopyFlowChart.splice(ifConditionIndex, endIfIndex - ifConditionIndex);
    // this.testCopyFlowChart.forEach((element, i)=>
    // {
    //   element.stepIndex=i;
    //   element.viewS=true;
    //   if(element.commandName == 'IF' || element.commandName=='FOR')
    //   {
    //     element['children'] = ifChildren;
    //   }
    //   element['view']='vertical';
    // })

    // console.log("Flowchart : ",this.testCopyFlowChart);

    // console.log(this.testStepCopy);

  }

  loadUser() {
    // this.userService.getUser().subscribe((res: any)=>{
    //   this.cardView = res.isCardView == 'true' ? true : false;
    //   localStorage.setItem('currentUser', JSON.stringify(res));
    //   this.testCase.setView(this.cardView);
    // })

    {
      if (!JSON.parse(localStorage.getItem('currentUser'))) {
        this.userService.getUser().subscribe((res: any) => {
          this.cardView = res.isCardView == 'true' ? true : false;
         
          this.testCase.setView(this.cardView);
          if(this.cardView){
            this._router.navigate(['/flow-chart/' + this.projectId + '/' + this.testId + '/' + this.testStepId]);
          }
        })
      }
      else {
        var resp = JSON.parse(localStorage.getItem('currentUser'));
        this.cardView = resp.isCardView == 'true' ? true : false;
        this.testCase.setView(this.cardView);
      }

    }
  }
  changeDefaultView(data) {
    this.userManagement.updateDefaultView(data).subscribe((res) => {
      this.toastrService.clear();
      this.toastrService.success("Default view updated successfully");
      this.userService.getUser().subscribe((res: any) => {
        localStorage.setItem('currentUser', JSON.stringify(res));
        this.cardView = res.isCardView == 'true' ? true : false;
        this.testCase.setView(this.cardView);
        if (this.indexFormArray) {
          let removeArray = this.indexFormArray.value;
          for (let i = 0; i < removeArray.length; i++) {
            this.onChange(removeArray[i], false);
          }
        }
      })
    })
  }

  removeUrlSyntax(arr) {
    let count = 0;
    //arr);

    for (let index = 0; index < arr.length; index++) {
      //);

      if (arr[index]['url'].includes('test/TestStep')) {
        count++;
        if (count > 1) {
          //'arr1', arr);

          //arr[index]);

        }
      }

    }

  }
  closeDropdown() {
    $('.hl-miniMap').removeClass('margin-left-horizontal-chart');
    $('.hl-chooseCatogeryWrapper').removeClass('show');
    this.globalSearch = undefined;
    this.searchAction()
  }
  showCategory() {
    $('.hl-chooseCatogeryWrapper').removeClass('show');
    $('.hl-actionWrapper').addClass('show');
  }
  closeCatDropdown() {
    $('.hl-actionWrapper').removeClass('show');
    $('.hl-miniMap').removeClass('margin-left-horizontal-chart');
    this.globalSearch = undefined;
    this.searchAction();
  }
  getTestStepInfo(actionName, functionName) {
    //'actionName : ', actionName, ' functionName : ', functionName);
    var functionData;
    var alterFunctionName;
    if (functionName !== '' && functionName.startsWith('${__')) {
      functionData = functionName.substring(4, functionName.length - 1).split('(');
      //'functionData', functionData);

      alterFunctionName = functionData[0];
      //'subFunction', functionData);
      if (functionData[1].includes("operation") || functionData[1].includes("cmd") || functionData[1].includes("action")) {
        var subFunction = functionData[1].split('=')[1]; // return function name
        //'subfunction', subFunction);

        this.highlite = subFunction.split(',')[0].replace(')', '')
        //'highlite', this.highlite);

      }
    } else {
      alterFunctionName = 'NOFUNCTION'
    }

    this.testCase.getTestStepInfo(actionName, alterFunctionName).subscribe((data) => {
      this.testStepInfo = []
      this.functionInfo = []
      this.testStepInfo = data.command;
      this.functionInfo = data.function;
    })
  }

  @ViewChild(MatMenuTrigger, null)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: '0px', y: '0px' };

  loadFormData(indexes) {

    this.testStepIndex = indexes;
    this.showFormUpdateFlag = true;

  }

  /**
   * @author Vivek Gajbhiye
   * @param action
   * @value 'undo' or 'redo'
   *
   */
  redoUndoAction(action) {
    this.router = this._router.url;
    this.route.paramMap.subscribe(
      params => {
        ////'params', params); 
        if (action === 'undo') {
          this.http.get(this.url + '/HuLoopRest/huloop/test/redoUndoAction' + '/' + params.get('pid') + '/' + params.get('tid') + '/' + params.get('tsid') + '/undo').
            subscribe(undo => {
              if (undo) {
                // this.getInitTestSteptData();
                // alert(undo);
                console.log('undo',undo);
                
                this.testStepdata = undo;
                if (this.testStepdata.teststepList) {
                 this.testStep = [];
                 this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  this.loadFlowchart(this.testStep);
                  ////'redo data', this.testStepdata);
                  // alert(redo);
                  this.toastrService.clear();
                  this.toastrService.success('Action performed successfully');
                }
                else {
                  this.testStep = [];
                  this.loadFlowchart(this.testStep);
                }
              }
              else {
                this.toastrService.clear();
                this.toastrService.info('No data is avaialble');
              }
            })
        } else {
          this.http.get(this.url + '/HuLoopRest/huloop/test/redoUndoAction' + '/' + params.get('pid') + '/' + params.get('tid') + '/' + params.get('tsid') + '/redo').
            subscribe(redo => {
              if (redo) {
                this.testStepdata = redo;
                console.log(this.testStepdata);
                if (this.testStepdata.teststepList) {
                  this.testStep = [];
                    this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  this.loadFlowchart(this.testStep);
                  ////'redo data', this.testStepdata);
                  // alert(redo);
                  this.toastrService.clear();
                  this.toastrService.success('Action performed successfully');
                }
                else {
                  this.testStep = [];
                  this.loadFlowchart(this.testStep);
                }
              }
              else {
                this.toastrService.clear();
                this.toastrService.info('No data is avaialble');
              }

            })
        }
      })
  }
  loadTestCaseData() {
    this.router = this._router.url;
    if (!JSON.parse(localStorage.getItem('testCassedata'))) {
      this.http.get(this.url + '/HuLoopRest/huloop/test/testSuiteData/' + this.projectId + '/' + this.testId).
        subscribe(data => {
          this.testCaseData = data;
          this.testCassedata = JSON.parse(JSON.stringify(this.testCaseData))
          var items: string[] = [];
          for (let i of this.testCaseData.testCaseData) {
            items.push(i.id);
          }
          this.testCaseData = items;
          ////'testcasedata',this.testCaseData);
          if (items[0] == this.testStepId) {
            this.disablePreviosBUtton = false;
          }

          if (items[items.length - 1] == this.testStepId) {
            this.disableNextBUtton = false;
          }
          return;
        })
    }
    else if (JSON.parse(localStorage.getItem('testCassedata'))) {
      this.testCaseData = JSON.parse(localStorage.getItem('testCassedata'));
      this.testCassedata = JSON.parse(JSON.stringify(this.testCaseData))
      var items: string[] = [];
      for (let i of this.testCaseData.testCaseData) {
        items.push(i.id);
      }
      this.testCaseData = items;
      ////'testcasedata',this.testCaseData);
      if (items[0] == this.testStepId) {
        this.disablePreviosBUtton = false;
      }

      if (items[items.length - 1] == this.testStepId) {
        this.disableNextBUtton = false;
      }
      return;
    }

  }
  setTestData(id) {
    ////id);
    ////this.testCassedata);

    this.testCaseStep = this.testCassedata['testCaseData'].filter((f) => f.id === id);
    this.testCase.setDataForUpdate(this.testCaseStep);
    ////this.testCaseStep);
    this.confirmationDialogService.openFormPopUp(this.testCaseStep)
      .afterClosed().subscribe(res => {
        if (res) {
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testSuiteData/' + this.projectId + '/' + this.testId).
            subscribe(
              (data) => {

                this.testCassedata = data;
                this.testCaseStep = this.testCassedata['testCaseData'].filter((f) => f.id === id);
                ////this.testCaseStep);
                this.testStepdata.title = this.testCaseStep[0].title;
                this.toastrService.clear();
                this.toastrService.success('Case Name updated successfully');


              }
            )
        }
        // this.refreshPage();
      });
    // this.router.navigate(['/data/manage-test-data/' + this.projectId])
  }

  goPrevious() {
    let index = this.testCaseData.findIndex(x => x === this.testStepId);
    if (index == 0) {
      this.disablePreviosBUtton = false;
    }
    ////this.testCaseData);
    if (index > 0) {
      this.disableNextBUtton = true;
      ////'current index',index);
      ////'testcase data', this.testCaseData);
      let result = this.testCaseData[index - 1];
      // let result1 = result;
      // ////'previous index id',result);
      var currentIndex = this.testCaseData.findIndex(x => x === result);
      ////currentIndex);
      if (currentIndex == 0) {
        this.disablePreviosBUtton = false;
        ////);

      }
      else {
        this.disablePreviosBUtton = true;
      }
      this._router.navigate(['/TestStep/' + this.projectId + '/' + this.testId + '/' + result]);
    } else {

    }

  }


  goNext(curid) {
    ////'curdid', curid);
    this.disablePreviosBUtton = true;
    let index = this.testCaseData.findIndex(x => x === curid);
    if (index < this.testCaseData.length) {
      ////'current index',index);
      ////'testcase data', this.testCaseData);
      let result = this.testCaseData[index + 1];
      // let result1 = result;
      ////'next index id',result);
      ////this.testCaseData);
      var currentIndex = this.testCaseData.findIndex(x => x === result);
      ////currentIndex);
      this.disableNextBUtton = true;
      if (currentIndex == this.testCaseData.length - 1) {
        this.disableNextBUtton = false;
        ////'Enable');

      }
      else if (result == undefined) {
        this.disableNextBUtton = false;
        this.disablePreviosBUtton = true;
      }
      else {
        this.disableNextBUtton = true;
      }
      let url = this._router.navigate(['/TestStep/' + this.projectId + '/' + this.testId + '/' + result]);
      ////'next url ', url);
    }
    // if(index < this.testCaseData.lenght){


    // }

  }


  onPageChange(newValue) {
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }




  saveState() {
    // this.projectId;
    const updateTestStepData = this.testStepdata;
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    ////myFinalObject);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/true', myFinalObject).
      subscribe((data) => {
        if (data) {
          ////'save state',data);
          this.toastrService.success('Step Updated successfully');
        }
      });
  }



  differentTreeSelected(t) {
    ////t);
    if (this.currentlySelectedTree !== t) {
      this.treelistsvc.setCurrentlySelectedTree(t);
      this.closeSideNav();
    }

  }

  refreshPage() {
    this.document.defaultView.location.reload();
  }

  openSideNav() {
    this.myNav.open();
  }

  closeSideNav() {
    this.myNav.close();
  }

  addNode(n) {

  }

  getActions = function () {
    this.testCase.getAction(this.projectType).subscribe(
      (data) => {
        if (data && data.list && data.list.length !== this.actions.length) {
          for (var i = 0; i < data.list.length; i++) {
            if (typeof (data.list[i]) == 'string' && JSON.parse(data.list[i])) {
              var obj = JSON.parse(data.list[i]);
              this.actions.push(obj);
            }
          }
          this.actions = _.chain(this.actions).sortBy('name').value();

        }
        ////"actions : ", this.actions);
      });
  }

  getGroupedAction() {
    return this.testCase.getGroupedAction().subscribe(
      (data) => {
        this.groupedActionData = data;
        localStorage.setItem('groupedActionData', JSON.stringify(this.groupedActionData))
        console.log(this.groupedActionData);

        this.colors = ["#956fa1", "#7aa19f", "#49A1F1", "#3685F6", "#6750A4", "#8E7AAE", "#FDBA13",
          "#EAB62F", "#F58820", "#d080d9", "#5DA6B7", "#f5817d", "#B5D654", "#44B94A",
          "#5CB587", "#2C8B7F", "#c9b5b3", "#EB4D3D", "#9cdbad", "#9cd6cc", "#68ada1",
          "#e8b3f2", "#c293cc", "#d199c8", "#f590e4", "#d6c696", "#ffe28a", "#f7a06d"
        ];

        var Icons = [
          "fab fa-chrome",
          "fas fa-location-arrow",
          "fas fa-file-word",
          "fas fa-file-excel",
          "fas fa-folder-plus",
          "fas fa-mobile-alt",
          "fas fa-recycle",
          "fas fa-database",
          "fas fa-desktop",
          "fas fa-spell-check",
          "fas fa-pause-circle",
          "fas fa-sitemap",
          "fas fa-terminal",
          "fas fa-file-pdf",
          "fas fa-keyboard",
          "fas fa-mouse",
          "fas fa-file-csv",
          "fas fa-exclamation-triangle",
          "fas fa-check-double",
          "fas fa-hand-pointer",
          "fas fa-toolbox",
          "fas fa-images",
          "fas fa-file-code",
          "fas fa-scroll",
          "fas fa-code-branch",
          "fas fa-laptop-code",
          "fas fa-tools",

        ]
        this.groupedActionData.forEach((element, i) => {
          element.groupColor = '#002d5b';
          element.children.forEach(elementChild => {
            elementChild.color = element.groupColor;
            elementChild.icon = element.groupIcon;
            element.icon = element.groupIcon;
            if (elementChild.type == 'sub') {
              elementChild.subfunction.forEach(elementSub => {
                elementSub.color = element.groupColor;
                elementSub.icon = element.groupIcon;
                // element.icon = Icons[i]
              });
            }
          });
        });
        this.groupedActionDataCopy = JSON.parse(JSON.stringify(this.groupedActionData))
        console.log('ata', this.groupedActionDataCopy);

        this.loadActionsMetaData();
        setTimeout(() => {
          this.mapActionPse(this.functions, this.actions);
        }, 1000);
        return;
      }
    )
  }

  loadActionsMetaData() {
    return this.groupedActionData.forEach(groupedActionItem => {
      groupedActionItem.children.forEach(action => {
        if (action.type == 'action') {
          this.actionsMetaData[action?.children?.name] = action?.name;
          this.actionsMetaDataCopy[action?.children?.name] = action.name;
        } else if (action.type == 'fun') {
          this.actionsMetaData[action?.function?.name] = action?.name;
          this.actionsMetaDataCopy[action?.function?.name] = action?.name;
        } else if (action.type == 'sub') {
          this.actionsMetaData[action.subfunction[0]?.children?.name] = action?.name;
          this.actionsMetaDataCopy[action.subfunction[0].children?.name] = action?.name;
          // action.subfunction[0]
          // action.subfunction.forEach(subfunction => {
          //   this.actionsMetaData[subfunction.children.name] = subfunction.name;
          // });
        }
      });
      this.actionsMetaData['OPEN'] = 'Open Web Browser';
      this.actionsMetaDataCopy['OPEN'] = 'Open Web Browser';
    });

  }

  getAllProjectSetting = function () {
    this.testCase.getAllProjectSetting(this.projectId).subscribe(
      (data) => {

        if (data.projectSettingList) {
          const variables = [] as any;
          //  //console.log(data.projectSettingList.length);
          for (var i = 0; i < data.projectSettingList.length; i++) {
            if (data.projectSettingList[i].type === 'GLOBAL' || data.projectSettingList[i].name === 'cSetting') {
              for (var j = 0; j < data.projectSettingList[i].setting.entry.length; j++) {
                //   //console.log(data.projectSettingList[i].setting.entry.length);
                const tempData = data.projectSettingList[i].setting.entry[j];
                // //console.log("tempData", tempData);
                const temp = {
                  key: tempData.key,
                  variableType: data.projectSettingList[i].type
                };
                variables.push(tempData.key);
              }
            }
          }
          this.globalVariable = variables;
          //  //console.log(this.globalVariable);
        }

      }
    )
  }
  getFunction() {
    this.testCase.getFunction().subscribe(
      (data) => {
        ////'function', data);
        this.functionData = data['list'];
        const myJSON = JSON.stringify(this.functionData);
        ////'finctionJson', myJSON);
      }
    );

  }
  functionMethodNames: {};

  loadFunction = function () {
    //console.log("entry");

    var functionMethodNames = {};
    if (this.functions.length === 0) {
      //console.log("entry1");
      this.testCase.getFunction().subscribe((data) => {
        //console.log("entry2", data);
        if (data && data.list && data.list.length !== this.functions.length) {
          for (var i = 0; i < data.list.length; i++) {
            // if(typeof(data.list[i]) == 'string' && JSON.parse(data.list[i])){
            var obj = JSON.parse(data.list[i]);
            //console.log("objcheck", obj);
            this.functions.push(obj);
            functionMethodNames[obj.method] = obj.method;
            // }
          }
        }
        this.functions = _.chain(this.functions).sortBy('name').value();
        console.log('function', this.functions);
        // this.mapActionPse();
        //console.log("func", this.functions);

      });
    } else {
      return true;
    }
  }



  getFuntionField = function (fieldList, fieldName) {
    var matchingField;
    for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].name === fieldName) {
        matchingField = fieldList[i];
        break;
      }
    }
    return matchingField;

  }

  // editTestCaseTestSteps() {
  //   this.testCase.editTestCaseTestSteps().subscribe(
  //     (data) => {
  //       ////'editTestCaseTestSteps>>', data)
  //     }
  //   );
  // }

  sendIndex(Index) {
    this.Index = Index;
    ////Index + 1);
    const IndexMsg = Index + 1;
    this.stepsTobeDelete = this.testStep[this.Index];
    ////'>>', this.stepsTobeDelete);
    if (this.cardView) {
      this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + IndexMsg + ' index Card ?')
        .afterClosed().subscribe(res => {
          if (res) {
            this.filterArr();
            this.toastrService.clear();
            this.toastrService.success('Card ' + IndexMsg + ' Deleted successfully');
          }
        });
    }
    else {
      this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete ' + IndexMsg + ' index record ?')
        .afterClosed().subscribe(res => {
          if (res) {
            this.filterArr();
            this.toastrService.clear();
            this.toastrService.success('Step ' + IndexMsg + ' Deleted successfully');
          }
        });
    }

  }

  filterArr() {
    ////this.testStep.length);
    this.initiateDelTestStep = this.testStep;
    for (var i = 0; i < this.initiateDelTestStep.length; i++) {

      if (this.initiateDelTestStep[i] === this.stepsTobeDelete) {

        this.initiateDelTestStep.splice(i, 1);
      }

    }
    ////this.initiateDelTestStep);



    // this.projectId;
    // ////this.projectId);
    // ////this.testStepId);
    this.testStepdata.teststepList = this.initiateDelTestStep;
    const updateTestStepData = this.testStepdata;
    ////updateTestStepData);
    // const myObject = updateTestStepData[0];
    // var myFinalObject = _.omit(myObject, ['parentNestedBlock']);
    // ////myFinalObject);
    if(this.logEntry=="false" ||this.logEntry==false ){
      this.testCase.editDelete(this.projectId,this.testId,this.testStepdataCopy).subscribe(
        (data)=>{
          this.logEntry = "true";
        }
      )
    }
    
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', updateTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                if (this.indexFormArray) {
                  let removeArray = this.indexFormArray.value;
                  for (let i = 0; i < removeArray.length; i++) {
                    this.onChange(removeArray[i], false);
                  }
                }

                // ////this.testStepdata);
          
           
                if (this.testStepdata['teststepList']) {
                  this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;

                  }
                  this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
                  this.visibleIndexForCardTip = this.testStep.length
                  this.objectForEditTestStep = undefined;
                  this.editEnable( this.testStep[0], 0 )
                  this.loadFlowchart(this.testStep);
                  this.loadTestStepData = false;
                  setTimeout(() => {
                    this.getIncludedTestCases();
                  }, 1000);
                  
                }
                else {
                  this.testStepCopy = [];
                  this.testStep = []
                  this.loadFlowchart(this.testStep);
                }

              }
            )

        }
      });

  }

  getActionCommandDes(action) {
    var desc = this.actions.filter((f) => f.name === action);
    if(desc[0]){
    this.commandDesc = desc[0].desc;
      return this.commandDesc;
    }
  
    //this.commandDesc);

  }


  addRow(commandName?: string) {
    this.testStepAtSelectedIndex = {
      active: "ENABLE",
      commandName: "",
      comment: "",
      runtimeData: 'false',
      debug: "",
      elementKey: "",
      evaluatedMetaValue: "",
      maskedData: "",
      pageName: "",
      parameters: {
        settingValue: '',
        isMasked: 'false'
      },
      result:
      {
        startTime: '0', endTime: '0', duration: '0.0',
        resultState:
        {

        },
        aggrResultState: {

        },
      },
      runState: "",
      testData: "",
      type: "AUTOMATIC",
    }
    if (this.testCaseType == 'MANUAL') {
      this.testStepAtSelectedIndex.type = 'MANUAL';
    }
    // this.testStepAtSelectedIndex = this.testStep[0];
    ////"formTestStep", this.testStepAtSelectedIndex);
    if (commandName) {
      this.testStepAtSelectedIndex.commandName = commandName;
    }
    else {
      if (this.projectType === 'WEB') {
        this.testStepAtSelectedIndex.commandName = 'OPEN';
      } else if (this.projectType === 'DESKTOP') {
        this.testStepAtSelectedIndex.commandName = 'OPENDESKTOPAPP';
      } else if (this.projectType === 'MOBILE') {
        this.testStepAtSelectedIndex.commandName = 'OPENMOBILEAPP';
      } else if (this.projectType === 'MIXED') {
        this.testStepAtSelectedIndex.commandName = 'OPENBROWSER';
      }
      else if (this.projectType === 'REST') {
        this.testStepAtSelectedIndex.commandName = 'REQ_START';
      }
      else {
        this.testStepAtSelectedIndex.commandName = 'OPEN';
      }
    }
    // this.arr = testStepUpdateForm.value;


    // this.testStepAtSelectedIndex.commandName = 'OPEN';
    this.testStep = [];
    // this.testStep = this.testStepdata.teststepList;
    const items = this.testStep;
    ////items);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]

    const result = insert(items, 0, this.testStepAtSelectedIndex)


    this.testStepdata.teststepList = result;
    ////"Create", result);
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.checkAllTestSteps = false;
          this.testStepdata = data;
          if (commandName) {
            var item = {
              projectId: this.projectId,
              parentId: this.testStepdata.parentTestDataId,
              testStepId: this.testStepdata.id,
              index: 1,
              pseCommand: this.actionsMetaData[commandName]
            }
          }
          else {
            var item = {
              projectId: this.projectId,
              parentId: this.testStepdata.parentTestDataId,
              testStepId: this.testStepdata.id,
              index: 1,
              pseCommand: this.actionsMetaData[this.testStepAtSelectedIndex.commandName]
            }
          }

          ////item);
          ////'Updaaateee')
          var authCheck = this.cookieService.get('loginSubscriptionData');;
          ////authCheck);
          if (authCheck && !this.cardView) {
            this.confirmationDialogService.openUpdatePopUp(item, this.testStepdata.path, 'test-step', 'Add')
              .afterClosed().subscribe(
                (res) => {
                  ////res);

                  this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                    subscribe(
                      (data) => {
                        this.testStepdata = data;
                        this.testStep = this.testStepdata.teststepList;
                        for (let i = 0; i < this.testStep.length; i++) {
                          this.testStep[i].stepIndex = i;
                          this.testStep[i].viewS = true;
                          ////this.testStep);
                          this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
                          if (this.testStep[i].commandName == 'UNKNOWN') {
                            ////i);
                            this.stepsTobeDelete = this.testStep[i];
                            
                            this.filterArr();
                            this.toastrService.clear();
                            this.toastrService.success(' Can not add unknown command');
                            return;
                          }
                        }
                        setTimeout(() => {
                          this.loadTestStepData=false;
                          this.getIncludedTestCases();
                          this.loadFlowchart( this.testStep)
                        }, 0);
                        this.toastrService.clear();

                        this.toastrService.success('Step updated successfully');
                      }
                    )

                });
          }
          console.log('DataAddR', this.testStepdata);
          // teststepList
          if(this.cardView){
            this.testStep = this.testStepdata.teststepList;
            for (let i = 0; i < this.testStep.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStep[i].stepIndex = i;
              this.testStep[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length
             
            }
            this.objectForEditTestStep = undefined;
            this.loadFlowchart( this.testStep)
            
            this.editEnable( this.testStep[0], 0)
          // this.loadFlowchart()

          }
        }
      });
  }
  addFunctions(lastIndex, buttonIdentifier, commandName) {
    if (this.actionType == 'action') {

      this.addBelow(lastIndex, buttonIdentifier, commandName);
      this.droppedStep = undefined
    }
    if (this.actionType == 'fun') {
      this.droppedStep = this.functions.filter(f => (f.name == commandName));
      console.log(this.droppedStep);

    }

    if (this.subFunctionType == 'sub') {
      this.droppedStep = this.functions.filter(f => (f.name == this.FunctionName));
    }
    if (this.droppedStep) {
      if (this.droppedStep[0]) {
        this.addBelow(lastIndex, buttonIdentifier, 'SET');
      }
    }
    // else {
    //   this.addBelow(lastIndex, buttonIdentifier, commandName);
    // }
  }

  addBelow(lastIndex, buttonIdentifier, commandName?: string) {
    ////"addBello");
    this.checkAllTestSteps = false;
    const items = this.testStep;
    //  const lastIndex =this.testStep.length;
    ////lastIndex);
    const insert = (arr, index, newItem) => [
      // part of the array before the specified index
      ...arr.slice(0, index),
      // inserted item
      newItem,
      // part of the array after the specified index
      ...arr.slice(index)
    ]
    this.testStepCopy[0] = JSON.parse(JSON.stringify(this.testStep[0]));
    

    if (this.projectType === 'WEB') {
      this.testStepCopy[0].commandName = commandName;
    } else if (this.projectType === 'DESKTOP') {
      this.testStepCopy[0].commandName = 'OPENDESKTOPAPP';
    } else if (this.projectType === 'MOBILE') {
      this.testStepCopy[0].commandName = 'OPENMOBILEAPP';
    } else if (this.projectType === 'MIXED') {
      this.testStepCopy[0].commandName = commandName;
    }
    else if (this.projectType === 'REST') {
      this.testStepCopy[0].commandName = 'REQ_START';
    }
    else {
      this.testStepCopy[0].commandName = 'OPEN';
    }
    this.testStepCopy[0].comment = '';
    this.testStepCopy[0].runtimeData = 'false';
    this.testStepCopy[0].elementKey = '';
    this.testStepCopy[0].parameters.settingValue = '';
    this.testStepCopy[0].parameters.isMasked = 'false';
    this.testStepCopy[0].pageName = '';
    this.testStepCopy[0].type = 'AUTOMATIC';
    this.testStepCopy[0].active = 'ENABLE';
    if (this.testCaseType == 'MANUAL') {
      this.testStepCopy[0].type = 'MANUAL';
    }
    const result = insert(items, lastIndex, this.testStepCopy[0])

    ////this.testStep[0]);
    ////"insert", result);
    // [1, 10, 2, 3, 4, 5]
    var testStepAtSelectedIndex = this.testStepCopy[0];
    // ////"fromTestStep",this.testStepAtSelectedIndex);
    // testStepAtSelectedIndex.push(this.testStep);

    ////"Create", this.testStep);
    // this.projectId;
    ////this.projectId);
    ////this.testStepId);
    this.testStepdata.teststepList = result;
    ////"Create", result);
    this.testStepCopy = JSON.parse(JSON.stringify(result));
    this.testCopyFlowChart = JSON.parse(JSON.stringify(result));
    // this.loadFlowchart(result);
    for (let i = 0; i < this.testStepCopy.length; i++) {
      // this.testStep[i] = {
      //    stepIndex:''
      //   }
      this.testStepCopy[i].stepIndex = i;
      this.testCopyFlowChart[i].stepIndex = i;
      ////this.testStep);
      // this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
      ////this.testStepCopy);


    }
    const createTestStepData = this.testStepdata;
    ////createTestStepData);
    const myObject = createTestStepData[0];
    this.testCase.editTestCase(this.projectId, this.testId, createTestStepData).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.testStepdata = data;
          this.testStep = this.testStepdata.teststepList;
          if(this.cardView){
            for (let i = 0; i < this.testStepdata.teststepList.length; i++) {
              // this.testStep[i] = {
              //    stepIndex:''
              //   }
              this.testStepdata.teststepList[i].stepIndex = i;
              this.testStepdata.teststepList[i].viewS = true;
              ////this.testStep);
              this.visibleIndexForCardTip = this.testStepdata.teststepList.length
             
            }
            this.loadFlowchart(this.testStepdata.teststepList)
            if (commandName == 'IF') {
              this.testStep = this.testStepdata.teststepList
              this.objectForEditTestStep = undefined;
              this.editEnable(this.testStepdata.teststepList[lastIndex-1], lastIndex-1)
              this.addBelow(lastIndex + 1, 'Add', 'ENDIF');
             
            }
            if (commandName == 'FOR') {
              this.testStep = this.testStepdata.teststepList
              this.objectForEditTestStep = undefined;
              this.editEnable(this.testStepdata.teststepList[lastIndex-1], lastIndex-1)
              this.addBelow(lastIndex + 1, 'Add', 'ENDFOR');
             
            }
          }
         
          const item = {
            projectId: this.projectId,
            parentId: this.testStepdata.parentTestDataId,
            testStepId: this.testStepdata.id,
            index: lastIndex + 1,
            pseCommand: this.actionsMetaData[commandName]
          }
          if (this.droppedStep?.length) {
            item['functionName'] = this.droppedStep[0].pseFunction + ',' + this.droppedStep[0].name;
            if (this.subFunctionType == 'sub') {
              item['subFunction'] = this.subFunctionObject;
            }
          }
         
          ////JSON.stringify(item), this.testStepdata.path);
          ////'Updaaateee')
          var authCheck = this.cookieService.get('loginSubscriptionData');;
          ////authCheck);
          console.log('DataAdd', this.testStepdata.teststepList[lastIndex]);
          if (this.cardView && commandName == 'ENDIF' || commandName == 'ENDFOR') {
            return;
            // this.editEnable(this.testStepdata.teststepList[lastIndex], lastIndex)
          }
         else if (this.cardView && commandName !== 'ENDIF' || commandName !== 'ENDFOR') {
            // return;
            this.objectForEditTestStep = undefined;
            this.editEnable(this.testStepdata.teststepList[lastIndex], lastIndex)
          }
         
            if (authCheck && !this.cardView) {
              this.confirmationDialogService.openUpdatePopUp(item, this.testStepdata.path, 'test-step', buttonIdentifier)
                .afterClosed().subscribe(
                  (res) => {
                    ////'respinseAddBelow',res);

                    this.subFunctionType = undefined;
                    this.subFunctionObject = undefined;
                    this.actionType = undefined;
                    this.droppedStep = undefined;
                    setTimeout(() => {
                      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                        subscribe(
                          (data) => {
                            this.testStepdata = data;
                            this.testStep = this.testStepdata.teststepList;
                            for (let i = 0; i < this.testStep.length; i++) {
                              // this.testStep[i] = {
                              //    stepIndex:''
                              //   }
                              this.testStep[i].stepIndex = i;
                              this.testStep[i].viewS = true;
                              ////this.testStep);
                              this.visibleIndexForCardTip = this.testStep.length

                              if (this.testStep[i].commandName == 'UNKNOWN') {
                                ////i);
                                this.stepsTobeDelete = this.testStep[i];
                                this.filterArr();
                                this.toastrService.clear();
                                this.toastrService.success(' Can not add unknown command');
                                return;
                              }
                            }

                            this.loadFlowchart(this.testStep);

                            setTimeout(() => {
                              this.loadTestStepData = false;
                              this.getIncludedTestCases();
                            }, 0);
                            ////this.testStep);
                            if (this.cardView) {
                              this.toastrService.clear();
                              this.toastrService.success('Card Added successfully to the flow at ' + item.index + ' index');
                            }
                            else {
                              this.toastrService.clear();
                              this.toastrService.success('Step Added  successfully at ' + item.index + ' index');
                            }
                          }
                        )
                    }, 1000);
                    //  this.refreshPage();

                  });
            }
          

        }
      });
  }

  insertComment(stepIndex) {
    this.testStepIndexForInsert = stepIndex;
    this.stepIndexForInsertComment = this.testStep[stepIndex];
    this.typeCheck = this.stepIndexForInsertComment.type;
    this.valueForUpdate = this.stepIndexForInsertComment.comment;
  }
  insertCommentL(key) {
    this.keyForinsertComment = key;
    this.valueForInsert = this.locatorEntryCommentValue.filter((f) => f.key == this.keyForinsertComment);
    this.valueForUpdate = this.valueForInsert[0].value;
    if (this.valueForUpdate == undefined) {
      this.valueForUpdate = 'Enter Comment'
    }
  }
  enableSubmitBUtton(value) {
    if (this.valueForUpdate != value) {
      this.enableBUtton = false;

    }
    else {
      this.enableBUtton = true;
    }
  }

  onSubmit(insertCommentForm) {

    this.formObj = insertCommentForm.value;
    this.stepIndexForInsertComment.comment = Object.values(this.formObj)[0];
    ////this.stepIndexForInsertComment);
    ////this.testStep);
    this.testCase.editTestCase(this.projectId, this.testId, this.testStepdata).subscribe(
      (data) => {
        ////data);
        this.testStepdata = data;
        this.cancelmodalforcomment.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success('comment added successfully');
        insertCommentForm.reset();
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {
              this.testStepdata = data;
              this.testStep = this.testStepdata.teststepList;

              for (let i = 0; i < this.testStep.length; i++) {
                // this.testStep[i] = {
                //    stepIndex:''

                //   }
                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;
                ////this.testStep);
                
                ////this.testStep);


              }
              this.visibleIndexForCardTip = this.testStep.length
                this.loadFlowchart(this.testStep);
            }
          )

      }
    )
  }
  updateTestStep(lastIndex, buttonIdentifier, isMasked, commandName?: string) {
    if (isMasked == 'true') {
      this.toastrService.clear();
      this.toastrService.warning('Can not Edit Encrypted Parameter, Decrypt to edit')
      return;
    }
    this.editStep = true;
    const item = {
      projectId: this.projectId,
      parentId: this.testStepdata.parentTestDataId,
      testStepId: this.testStepdata.id,
      index: lastIndex + 1,
      pseCommand: this.actionsMetaData[commandName]
    }
    ////item,this.moduleName);

    ////'Updaaateee')
    this.http.get(this.url + '/HuLoopRest/huloop/' + 'project/getAllProjectSettings/' + this.projectId).subscribe((
      data => {

        ////'projectSettingData', data);
        var authCheck = this.cookieService.get('loginSubscriptionData');;
        ////authCheck);
        if (authCheck) {
          this.confirmationDialogService.openUpdatePopUp(item, this.testStepdata.path, 'test-step', buttonIdentifier)
            .afterClosed().subscribe(res => {
              if (res) {
                setTimeout(() => {
                  this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                    subscribe(
                      (data) => {
                        this.testStepdata = data;
                        this.testStep = this.testStepdata.teststepList;

                        for (let i = 0; i < this.testStep.length; i++) {
                          // this.testStep[i] = {
                          //    stepIndex:''
                          //   }
                          this.testStep[i].stepIndex = i;
                          this.testStep[i].viewS = true;
                          ////this.testStep);
                          if (this.testStep[i].commandName == 'UNKNOWN') {
                            ////i);
                            this.stepsTobeDelete = this.testStep[i];
                            this.filterArr();
                            this.toastrService.clear();
                            this.toastrService.success(' Can not add unknown command');
                            return;
                          }
                        }
                        this.visibleIndexForCardTip = this.testStep.length
                        this.loadFlowchart(this.testStep);
                        this.loadTestStepData = false;
                        this.getIncludedTestCases();
                        ////this.testStep);
                        if (this.cardView) {
                          this.toastrService.clear();
                          this.toastrService.success('Card ' + item.index + ' updated successfully');
                        }
                        else {
                          this.toastrService.clear();
                          this.toastrService.success('Step ' + item.index + ' updated successfully');
                        }

                        this.editStep = false;
                      }
                    )
                }, 1000);

                //  this.refreshPage();
              }
            });
        }
      }
    ))

  }

  previousUrl: any;
  currentUrl: any;


  ngOnInit() {
    this.testCase.setStepForEdit(undefined)
    this.loadUser();
    const date = new Date();
    this.getLogging(this.testStepId);
    this.loadTestCaseData();
    this.initForms();
    this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
    if (JSON.parse(localStorage.getItem('projectDataById'))) {
      var res = JSON.parse(localStorage.getItem('projectDataById'));
      this.projectData = res;
      this.headerOptions.data = {
        projectId: this.projectId,
        projectName: res['projectName']
      };
      //set header details
      this.homeService.setHeaderOptions(this.headerOptions);
      this.moduleId = localStorage.getItem('moduleId')
      this.projectType = this.projectData.projectType;
      this.projectName = this.projectData.projectName;
      this.getActions();
      
      this.loadFunction();

      this.getAllProjectSetting();
      setTimeout(() => {
        this.getGroupedAction();
      }, 500);
      

      if (localStorage.getItem('copiedTestStep')) {
        this.enablePaste = true;
        this.enableCopyCheck = true;
      }
      if (localStorage.getItem('cutTestStepData')) {
        this.enableCutPaste = true;
      }
      return;
    }
    else if (!JSON.parse(localStorage.getItem('projectDataById'))) {
      this.project.getProjectById(this.projectId).subscribe((
        data => {
          this.projectData = data;
          this.headerOptions.data = {
            projectId: this.projectId,
            projectName: data['projectName']
          };
          //set header details
          this.homeService.setHeaderOptions(this.headerOptions);
          this.moduleId = localStorage.getItem('moduleId')
          this.projectType = this.projectData.projectType;
          this.projectName = this.projectData.projectName;
          ////this.projectData);
          ////'type',this.projectType);
          // this.filterParameter();

          // this.editTestCaseTestSteps();
          // this.projectName = this.projectData.projectName
          // this.getAllProjectSetting();

          this.getActions();
          // this.testCase.getView().subscribe((data) => {
          //   this.cardView = data;
          // })
          this.loadFunction();
          setTimeout(() => {
            this.getGroupedAction();
          }, 500);
          if (localStorage.getItem('copiedTestStep')) {
            this.enablePaste = true;
            this.enableCopyCheck = true;
            ////'paste',this.enablePaste);
          }
          if (localStorage.getItem('cutTestStepData')) {
            this.enableCutPaste = true;
          }

          return;
        }
      ))
    }

    
    this.findDvHeights();

  }
  getLogging(testCaseId){
    this.testCase.getLoggingResource(testCaseId).subscribe(
      (data)=>{
        this.logEntry = data;
        console.log('logEntry',this.logEntry);
  
      }
    )
  }
  initForms() {
    this.moveTestStepForm = this.formBuilder.group({
      orderIndex: ['', [Validators.required, Validators.min(1)]]
    })

    this.editLocatorTitleForm = this.formBuilder.group({
      name: ['', [Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/), Validators.required]],
    })

    this.addLocatorsForm = this.formBuilder.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      comment: ['']
    })

    this.updateLocatorsForm = this.formBuilder.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      comment: ['']
    })
  }
  geturlName(url) {
    if (url.includes('/setting/project-setting')) {
      return 'project-setting'
    }
    else if (url.includes('/test/TestStep/')) {
      return 'Test-step'
    }
    else if (url.includes('/test/TestSuit')) {
      return 'TestCase'
    }
    else if (url.includes('/test/TestStep/')) {
      return 'TestStep'
    }
    else if (url.includes('/data/manage-test-data')) {
      return 'Manage-test-data'
    }

  }
  get f() { return this.moveTestStepForm.controls; }
  findDvHeights() {
    var breadCrumbWrapperHeight;
    var projectButtonsListHeight;
    var headerHeight;
    breadCrumbWrapperHeight = $(".hl-breadcrumb-wrapper").innerHeight();
    projectButtonsListHeight = $(".hl-projectActionsButtonListContainer").innerHeight();
    headerHeight = $(".hl-header").innerHeight();
    var documentHeight = $(window).innerHeight();
    var totalHeight = documentHeight - breadCrumbWrapperHeight - projectButtonsListHeight - headerHeight - 50;
    $(".hl-miniMap").css("height", totalHeight + "px");
  }
  getProjectName() {
    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        this.projectType = this.projectData.projectType;
        ////this.projectData);
        ////'type',this.projectType)
        // this.projectName = this.projectData.projectName
      }
    ))
  }
  show() {
    this.hide = !this.hide;
  }




  // added code

  selectChangeHandler(event: any, index) {
    //console.log(index);

    this.contentDiv[index].parameterType = event;
    this.selectedValue = event;
  }


  selectedGVar(event: any, index) {
    this.contentDiv[index].parameterValue = event;
    this.contentDiv[index].parameterValue = this.contentDiv[index].parameterValue;
    this.selectedGvar = event;
    //console.log(this.contentDiv[index].parameterValue);
  }
  selectChangeAction(event: any) {
    this.selectedAction = event.target.value;
    this.selectedCase = undefined;
    this.selectedTestCase = undefined;
  }



  getLocator() {

    this.testCase.getLocatorSuite(this.projectId).subscribe(
      (data) => {
        this.locatorData = data['locatorSuite'];
      try {
        localStorage.removeItem('locatorData');
        if(this.locatorData){
          localStorage.setItem('locatorData',JSON.stringify(this.locatorData));
        }
        
      } catch (error) {
        
      }
        ////"locatorsuit>>",data);
        setTimeout(() => {
          this.getHighLight();
        }, 0);
      }
    )
  }
  getHighLight() {
    for (let lData of this.locatorData) {
      if (lData.locatorEntryMapEdited) {
        this.ScreenNameForHighLight = lData.locatorEntryMapEdited.entry[0].key;
        ////lData);

      }
      ////lData.locatorEntryMapEdited);

    }
  }

  clearHighLight(selectedIndex) {
    this.testStep[selectedIndex].result.resultState.status = 'NOTRUN';
    this.testStep[selectedIndex].result.resultState.notRunCount = "1";
    this.testStep[selectedIndex].result.resultState.modifiedCount = "0";
    ////this.testStep);
    const updateTestStepData = this.testStepdata;
    ////updateTestStepData);
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList']);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', myFinalObject).
      subscribe((data) => {
        if (data) {
          // this.toastrService.clear();
          // this.toastrService.success( 'Test Step Added succesfully');
          ////"upDateData", data);
          //  this.goBack();
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.indexFormArray = undefined;
                this.testStepdata = data;


                if (this.testStepdata['teststepList']) {

                  this.testStep = [];
                  this.testStep = this.testStepdata.teststepList;
                  this.testStep = this.testStepdata.teststepList;
                  for (let i = 0; i < this.testStep.length; i++) {

                    this.testStep[i].stepIndex = i;
                    this.testStep[i].viewS = true;
                    // ////this.testStep);
                  }
                  this.visibleIndexForCardTip = this.testStep.length
                  this.loadFlowchart(this.testStep);
                  this.loadTestStepData = false;
                  this.getIncludedTestCases();
                }
                else {
                  this.testStepCopy = [];
                }





              }

            )
          if (this.cardView) {
            this.toastrService.clear();
            this.toastrService.success(' Card updated successfully');
          }
          else {
            this.toastrService.clear();
            this.toastrService.success(' Step updated successfully');
          }
          //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
        }
      });
  }

  onClickSubmit(testStepUpdateForm) {
    this.testStepAtSelectedIndex = this.testStep[this.testStepIndex - 1];
    ////"formTestStep",this.testStepAtSelectedIndex);

    ////"hello", testStepUpdateForm.value);
    this.arr = testStepUpdateForm.value;

    if (this.testStepAtSelectedIndex) {
      if (this.arr.actOptions) {
        this.testStepAtSelectedIndex.commandName = this.arr.actOptions;
      }
      else {
        this.testStepAtSelectedIndex.commandName = this.selectedAction;
      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.pageName = this.arr.screenOptions;
      }
      else {
        this.testStepAtSelectedIndex.pageName = this.arr.Screen;
      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.elementKey = this.arr.screenOptions;
      }

      this.testStepAtSelectedIndex.parameters = this.arr.Parameter;
      ////this.selectedValue);
      if (this.selectedValue === 'Text') {
        this.testStepAtSelectedIndex.parameters = this.arr.Parameter;
      }

      if (this.selectedValue === 'Global Variable') {
        this.testStepAtSelectedIndex.parameters = '$G{' + this.arr.globalValue + '}';

      }

      if (this.selectedValue === 'Function') {
        ////this.arr);
        var functionValue = _.omit(this.arr, ['Action', 'actOptions', 'Screen', 'screenOptions', 'Element', 'elementKey']);
        ////functionValue);

        const myArray = Object.values(functionValue);
        this.testStepAtSelectedIndex.parameters = '${__' + this.methodname + '(' + myArray + ')' + '}';
      }
      if (!this.selectedValue) {
        this.testStepAtSelectedIndex.parameters = this.testStepAtSelectedIndex.parameters;
      }
      if (this.contentDiv) {
        //console.log(this.contentDiv);

        var paramName = '';
        for (let i = 0; i < this.contentDiv.length; i++) {

          if (this.contentDiv[i].parameterType == 'Text') {
            paramName = paramName + this.contentDiv[i].parameterValue;

          }
          if (this.contentDiv[i].parameterType == 'Global Variable') {
            paramName = paramName + '$G{' + this.contentDiv[i].parameterValue + '}';
          }

          if (this.contentDiv[i].parameterType == 'Function') {//isKeyValueFunction//isKeyValueFunction
            //console.log(this.contentDiv[i]['methodname']);
            if (this.keyValueFunctions.includes(this.contentDiv[i]['methodname']) || this.contentDiv[i]['isKeyValueFunction']) {
              let result = [];
              var warningMessage = '';
              this.contentDiv[i]['fieldlist'].forEach(data => {
                //console.log(data);

                if (data.isEditable == false && data.value == undefined) {
                  data.value = data.defaultValues[0];
                }
                if (data.isMandatory == true) {
                  // if(this.selectedSubfunction && data.isMandatory==true && data.isFieldDecideable==true){
                  //   data.value = this.selectedSubfunction
                  // }
                  if (data.value == undefined || data.value == '') {
                    warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                  }

                }
                if (data.isMandatory == false) {
                  if (data.value == undefined || data.value == '') {
                    data.value = ' ';
                    //console.log(data);

                  }

                }


                let result1 = data.name + "=" + data.value;
                result.push(result1);



              });

              if (warningMessage && warningMessage.length > 0) {
                // warningMessage = $scope.toCamelCase(warningMessage);
                this.toastrService.clear();
                this.toastrService.warning(warningMessage, null, {
                  enableHtml: true
                });
                return;
              }
              let finalValue = result.join();
              paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
              //console.log(paramName);
              if (this.contentDiv[i]['result4']) {
                //console.log(this.contentDiv[i]['result4']);
                let varResult = []
                for (let j = 0; j < this.contentDiv[i]['result4'].length; j++) {
                  this.contentDiv[i]['result4'][j].forEach(data1 => {

                    let varResult1 = data1.value;

                    varResult.push(varResult1);

                  });
                }

                //console.log(varResult);

                let finaleValueOfVarFunc = varResult.join(',');

                //console.log(finaleValueOfVarFunc);

                //console.log('final',finaleValueOfVarFunc);


                paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ',' + finaleValueOfVarFunc + ')}';
              }
            }
            else {
              let result = [];
              var warningMessage = '';
              this.contentDiv[i]['fieldlist'].forEach(data => {
                //console.log(data);

                if (data.isEditable == false && data.value == undefined) {
                  data.value = data.defaultValues[0];
                }

                if (data.isMandatory == true) {
                  if (data.value == undefined || data.value == '') {
                    warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                  }

                }
                if (data.isMandatory == false || data.value == '') {
                  if (data.value == undefined) {
                    data.value = ' ';
                    //console.log(data);

                  }

                }

                let result1 = data.value;
                result.push(result1);

              });
              if (warningMessage && warningMessage.length > 0) {
                // warningMessage = $scope.toCamelCase(warningMessage);
                this.toastrService.clear();
                this.toastrService.warning(warningMessage, null, {
                  enableHtml: true
                });
                return;
              }
              let finalValue = result.join();
              paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
              //console.log(paramName);
              if (this.contentDiv[i]['result4']) {
                //console.log(this.contentDiv[i]['result4'][i]);
                let varResult = []
                for (let j = 0; j < this.contentDiv[i]['result4'].length; j++) {
                  this.contentDiv[i]['result4'][j].forEach(data1 => {
                    if (data1.value != undefined) {
                      let varResult1 = data1.value;
                      varResult.push(varResult1);
                    }
                  });
                }
                let finaleValueOfVarFunc = varResult.join(',');
                console.log('final', finaleValueOfVarFunc);


                paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ',' + finaleValueOfVarFunc + ')}';
              }
            }


            // //console.log(this.contentDiv[i]['parameterArg']);
            // if (this.contentDiv[i]['parameterArg']) {
            //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
            //   //console.log('result1', this.contentDiv[i]['result1']);

            //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
            //   if (!this.contentDiv[i]['isKeyValueFunction']) {
            //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
            //   }

            // }
            // else {
            //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
            //   //console.log('result1', this.contentDiv[i]['result1']);
            //   if (!this.contentDiv[i]['isKeyValueFunction']) {
            //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
            //   }
            // }

            // if (this.contentDiv[i]['isKeyValueFunction']) {
            //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
            //     this.contentDiv[i]['result2'].forEach((value, index2) => {
            //       //console.log(index1, index2)
            //       if (index1 == index2) {
            //         let obj = { 'name': element, 'value': value }
            //         if(!this.contentDiv[i]['result3'])
            //         {
            //           this.contentDiv[i]['result3'] = [];
            //           this.contentDiv[i]['result3'].push(obj);
            //         }
            //         this.contentDiv[i]['result3'].push(obj);
            //       }
            //     });
            //   });

            //   let result = [];
            //   this.contentDiv[i]['result3'].forEach(data => {
            //     let result1 = data.name + "=" + data.value;
            //     result.push(result1);
            //   });

            // let finalValue = result.join();
            // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            // //console.log(paramName);



            // else {

            // //console.log(this.contentDiv[i].parameterValue);

            //   let result = [];
            //   this.contentDiv[i]['fieldlist'].forEach(data => {
            //     let result1 = data.value;
            //     result.push(result1);
            //   });
            //   let finalValue = result.join();
            //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //     //console.log(paramName);

            //   // //console.log(this.contentDiv[i]['parameterArg']);
            //   // if (this.contentDiv[i]['parameterArg']) {
            //   //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
            //   //   //console.log('result1', this.contentDiv[i]['result1']);

            //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
            //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
            //   //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
            //   //   }

            //   // }
            //   // else {
            //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
            //   //   //console.log('result1', this.contentDiv[i]['result1']);
            //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
            //   //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
            //   //   }
            //   // }

            //   // if (this.contentDiv[i]['isKeyValueFunction']) {
            //   //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
            //   //     this.contentDiv[i]['result2'].forEach((value, index2) => {
            //   //       //console.log(index1, index2)
            //   //       if (index1 == index2) {
            //   //         let obj = { 'name': element, 'value': value }
            //   //         if(!this.contentDiv[i]['result3'])
            //   //         {
            //   //           this.contentDiv[i]['result3'] = [];
            //   //           this.contentDiv[i]['result3'].push(obj);
            //   //         }
            //   //         this.contentDiv[i]['result3'].push(obj);
            //   //       }
            //   //     });
            //   //   });

            //   //   let result = [];
            //   //   this.contentDiv[i]['result3'].forEach(data => {
            //   //     let result1 = data.name + "=" + data.value;
            //   //     result.push(result1);
            //   //   });

            //     // let finalValue = result.join();
            //     // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //     // //console.log(paramName);
            //     if(this.contentDiv[i]['result4']){
            //     //console.log(this.contentDiv[i]['result4'][i]);
            //     let varResult = []
            //     this.contentDiv[i]['result4'][i].forEach(data1 => {

            //       let varResult1 = data1.name + "=" + data1.value;
            //       varResult.push(varResult1);
            //     });
            //     let finaleValueOfVarFunc = varResult.join();
            //     //console.log('final',finaleValueOfVarFunc);


            //       paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue +','+ finaleValueOfVarFunc + ')}';
            //   }


            // }

            // }

          }




        }


        // //console.log("final result3");


        if (this.contentDiv[0]['parameterType'] != undefined) {
          //console.log(this.contentDiv);

          this.testStepAtSelectedIndex.parameters['settingValue'] = paramName;
        }

        //console.log('param', paramName);

      }
      this.testStepAtSelectedIndex.elementKey = this.arr.Element;

    }

    this.updateTestSteps();

  }




  updateTestSteps() {

    const updateTestStepData = this.testStepdata;
    ////updateTestStepData);
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    ////myFinalObject);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', myFinalObject).
      subscribe((data) => {
        if (data) {

          this.cancelmodal.nativeElement.click();
          if (this.cardView) {
            this.toastrService.clear();
            this.toastrService.success(' Card updated successfully');
          }
          else {
            this.toastrService.clear();
            this.toastrService.success(' Step updated successfully');
          }

          //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
        }
      });
  }

  close() {
    this._router.navigate(['/TestStep/' + this.projectId + '/' + this.testId + '/' + this.testStepId]);

  }
  goBack() {
    this.location.back();
  }

  onChange(index: any, isChecked: boolean) {
    this.checkedIndex=index
 if(!this.cardView){
  this.testStepCopy.forEach(element => {
    if (element.stepIndex == index) {
      element.checked = isChecked;
    }
  });

  let isAllTestCasesChecked = true;

  this.testStepCopy.forEach(element => {
    if (!element.checked) {
      isAllTestCasesChecked = false
    }
  });

  this.checkAllTestSteps = isAllTestCasesChecked;

  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;
  this.enableCopy = true;
  this.enableCut = true;
  if (isChecked) {

    this.indexFormArray.push(new UntypedFormControl(index));
    ////this.indexFormArray.value);
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
    this.indexFormArray.removeAt(Index);
    if (this.indexFormArray.value.length < 1) {
      this.enableCopy = false;
      this.enablePaste = false;
      this.enableCut = false;
    }
 }
 
    ////this.indexFormArray.value)
  }
else{
  // this.checkedIndex=index
  this.testCopyFlowChart.forEach(element => {
    if (element.stepIndex == index) 
    {
      element.checked = isChecked;
    }
    if(element.parentNestedBlock){
      element.parentNestedBlock[0].forEach(nestedElement => {
        if (nestedElement.stepIndex == index) {
          nestedElement.checked = isChecked;
        }
       
      });
    }
  });

  let isAllTestCasesChecked = true;

  this.testCopyFlowChart.forEach(element => {
    if (!element.checked) {
      isAllTestCasesChecked = false
    }
    if(element.parentNestedBlock){
      element.parentNestedBlock[0].forEach(nestedElement => {
        if (!element.checked) {
          nestedElement.checked = false;
        }
      });
    }
  });

  this.checkAllTestSteps = isAllTestCasesChecked;

  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;
  this.enableCopy = true;
  this.enableCut = true;
  if (isChecked) {

    this.indexFormArray.push(new UntypedFormControl(index));
    ////this.indexFormArray.value);
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == index)
    this.indexFormArray.removeAt(Index);
    if (this.indexFormArray.value.length < 1) {
      this.enableCopy = false;
      this.enablePaste = false;
      this.enableCut = false;
    }
}

   
  }
}
  copySelectedTestStep() {
    if (this.indexFormArray === undefined) {

      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to copy');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to copy');
      }

      ////'udefined',this.indexFormArray);

      return;
    }
    else if (this.indexFormArray.value.length < 1) {
      ////'empty',this.indexFormArray.value);
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to copy');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to copy');
      }
      return;
    }
    this.testStepArray = {
      id: JSON.parse(JSON.stringify(this.testStepId)),
      teststepList: []
    };
    this.enablePaste = true;
    this.enableCopyCheck = true;
    this.enableCutPaste = false;
    for (let i = 0; i < this.indexFormArray.value.length; i++) {
      this.testStepArray.teststepList.push(this.testStep[this.indexFormArray.value[i]]);
    }
    ////this.testStepArray.teststepList);

    localStorage.setItem('copiedTestStep', JSON.stringify(this.testStepArray));

    this.toastrService.clear();
    this.toastrService.success('Selected step copied successfully')
  }
  pasteStep(index) {
    ////this.testStepArray)
    var copiedSteps = localStorage.getItem('copiedTestStep');
    ////);

    if (copiedSteps) {

      this.testCase.pasteSteps(this.projectId, this.testStepId, this.testStepId, index, JSON.parse(copiedSteps)).subscribe(
        (data) => {
          ////data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                localStorage.removeItem('copiedTestStep');
                this.enablePaste = false;
                this.enableCopyCheck = false;
                this.testStepdata = data;
                this.testStep = this.testStepdata.teststepList;
                if (this.indexFormArray) {
                  let removeArray = this.indexFormArray.value;
                  for (let i = 0; i < removeArray.length; i++) {
                    this.onChange(removeArray[i], false);
                  }
                }

                for (let i = 0; i < this.testStep.length; i++) {
                  // this.testStep[i] = {
                  //    stepIndex:''
                  //   }
                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                  ////this.testStep);
                }
                this.visibleIndexForCardTip = this.testStep.length
                this.loadFlowchart(this.testStep);

                // ////removeArray);
                if (this.cardView) {
                  this.toastrService.clear();
                  this.toastrService.success('Selected Card pasted successfully');

                }
                else {
                  this.toastrService.clear();
                  this.toastrService.success('Selected step pasted successfully');

                }

              }
            )
        }
      )
    }

  }
  cutTestSteps(source) {
    if (this.indexFormArray === undefined) {
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to cut');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to cut');
      }
      return;
    }
    else if (this.indexFormArray.value.length < 1) {
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to cut');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to cut');
      }
      return;
    }
    this.cutTestStepArray = {
      list:
        this.indexFormArray.value
    }

    localStorage.setItem('cutTestStepData', JSON.stringify(this.cutTestStepArray));
    localStorage.setItem('sourceId', source);
    // ////this.cutTestStepArray)
    this.enableCutPaste = true;
    this.enablePaste = false;
    this.enableCopyCheck = false;
    this.toastrService.clear();
    this.toastrService.success('Selected step cut successfully')
  }
  cutPaste(index) {
    var cutTestStepData = localStorage.getItem('cutTestStepData');
    var sourceId1 = localStorage.getItem('sourceId').toString();


    this.testCase.cutPaste(this.projectId, sourceId1, this.testStepId, index, JSON.parse(cutTestStepData)).subscribe(
      (data) => {
        this.enableCutPaste = false;
        ////data)
        localStorage.removeItem('cutTestStepData');
        localStorage.removeItem('sourceId');
        setTimeout(() => {
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {

                this.testStepdata = data;
                this.testStep = this.testStepdata.teststepList;
                if (sourceId1 == this.testStepId) {
                  let removeArray = this.indexFormArray.value;
                  for (let i = 0; i < removeArray.length; i++) {
                    this.onChange(removeArray[i], false);
                  }

                }

                for (let i = 0; i < this.testStep.length; i++) {
                  // this.testStep[i] = {
                  //    stepIndex:''
                  //   }
                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                  ////this.testStep);
                }
                this.visibleIndexForCardTip = this.testStep.length
                this.loadFlowchart(this.testStep);

                // ////removeArray);
                if (this.cardView) {
                  this.toastrService.clear();
                  this.toastrService.success('Selected Card pasted successfully');
                }
                else {
                  this.toastrService.clear();
                  this.toastrService.success('Selected step pasted successfully');
                }

              }
            )
        }, 0);

      }
    )
  }
  removeSelectedRows() {

    if (this.indexFormArray === undefined) {
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to delete');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to delete');
      }
      ////'udefined',this.indexFormArray);

      return;
    }
    else if (this.indexFormArray.value.length < 1) {
      ////'empty',this.indexFormArray.value);
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to delete');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to delete');
      }
      return;
    }
    else if (this.indexFormArray.value.length > 0) {
      ////'empty',this.indexFormArray.value);
      let removeArray = this.indexFormArray.value;

      removeArray = removeArray.sort((a, b) => a - b);
      let testStepCopy = JSON.parse(JSON.stringify(this.testStep));
      for (let i = 0; i < removeArray.length; i++) {
        var temp;
        removeArray[i];
        temp = removeArray[i];
        ////temp);
        testStepCopy[temp] = {};
      }
      let testStep = testStepCopy.filter(value => JSON.stringify(value) !== '{}');
      ////this.testStep);
      this.testStepdata.teststepList = testStep;
      // this.testStepdata.teststepList.filter(value => JSON.stringify(value) !== '{}');
      ////this.testStepdata);
      this.confirmationDialogService.openConfirmDialog('Are you sure you want to delete selected steps ?')
        .afterClosed().subscribe(res => {
          if (res) {
            if(this.logEntry=="false" || this.logEntry==false){
              this.testCase.editDelete(this.projectId,this.testId,this.testStepdataCopy).subscribe(
                (data)=>{
                  this.logEntry = "true";
                }
              )
            }
            this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
              subscribe((data) => {
                if (data) {
                  // ////"upDateData", data);
                  this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
                    subscribe(
                      (data) => {
                        // sessionStorage.clear();
                        // localStorage.clear();
                        this.testStepdata = data;
                        this.indexFormArray = undefined
                        for (let i = 0; i < removeArray.length; i++) {
                          this.onChange(removeArray[i], false);
                        }
                        setTimeout(() => {
                          if (this.cardView) {
                            this.toastrService.clear();
                            this.toastrService.success('Selected  Card deleted successfully');
                          }
                          else {
                            this.toastrService.clear();
                            this.toastrService.success('Selected  step deleted successfully');
                          }

                          if (this.indexFormArray !== undefined) {

                            ////this.indexFormArray.value.length);
                          }
                          if (this.testStepdata['teststepList']) {
                            removeArray = [];
                            this.testStep = [];
                            this.testStep = this.testStepdata.teststepList;
                            this.testStep = this.testStepdata.teststepList;
                            for (let i = 0; i < this.testStep.length; i++) {

                              this.testStep[i].stepIndex = i;
                              this.testStep[i].viewS = true;
                              // ////this.testStep);
                            }
                            this.visibleIndexForCardTip = this.testStep.length
                            this.loadFlowchart(this.testStep);
                            this.loadTestStepData = false;
                            this.getIncludedTestCases();
                          }
                          else {
                            this.testStepCopy = [];
                            this.testStep = [];
                            this.loadFlowchart(this.testStep);
                          }
                        }, 100);



                      }
                    )
                  //  this.testStepdata=data;
                  //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
                }
              });
          }
        });
    }


  }

  skipSelectedRows() {
    if (this.indexFormArray === undefined) {
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to skip/unskip');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to skip/unskip');
      }
      return;

    }

    if (this.indexFormArray.value.length < 1) {
      if (this.cardView) {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  card to skip/unskip');
      }
      else {
        this.toastrService.clear();
        this.toastrService.warning('Select atleast one  step to skip/unskip');
      }
      return;
    }
    let removeArray = this.indexFormArray.value;

    removeArray = removeArray.sort((a, b) => a - b)

    for (let i = 0; i < removeArray.length; i++) {
      var temp;
      removeArray[i];
      temp = removeArray[i];

      if (this.testStep[temp].active == 'DISABLE') {
        this.testStep[temp].active = 'ENABLE';
        //// this.testStep[temp])
      }
      else {
        this.testStep[temp].active = 'DISABLE';
        //// this.testStep[temp]);
      }
    }
    ////this.testStepdata);


    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
      subscribe((data) => {
        if (data) {
          ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.indexFormArray = undefined;
                this.testStepdata = data;

                ////removeArray);
                for (let i = 0; i < removeArray.length; i++) {
                  this.onChange(removeArray[i], false);
                }
                setTimeout(() => {

                  if (this.cardView) {
                    this.toastrService.clear();
                    this.toastrService.success('Selected Card(s) Skipped/Unskipped Successfully');
                  }
                  else {
                    this.toastrService.clear();
                    this.toastrService.success('Selected Step(s) Skipped/Unskipped Successfully');
                  }
                  // if(this.indexFormArray !== undefined){

                  //   ////this.indexFormArray.value.length);
                  //   this.selectAllBox.nativeElement.click()
                  // }
                  if (this.testStepdata['teststepList']) {
                    removeArray = [];
                    this.testStep = [];
                    this.testStep = this.testStepdata.teststepList;
                    this.testStep = this.testStepdata.teststepList;
                    for (let i = 0; i < this.testStep.length; i++) {

                      this.testStep[i].stepIndex = i;
                      this.testStep[i].viewS = true;
                      // ////this.testStep);
                    }
                    this.visibleIndexForCardTip = this.testStep.length
                    this.loadFlowchart(this.testStep);
                    this.loadTestStepData = false;
                    this.getIncludedTestCases();
                  }
                  else {
                    this.testStepCopy = [];
                  }
                }, 100);




              }

            )

        }
      });
  }

  toggleManual(i) {
    ////this.testStep[i])
    if(!this.enableEdit && this.cardView){
      this.toastrService.clear();
      this.toastrService.warning('Toggle not allowed, Cancel Edit Form then try to perform any Action');
      return;
    }
    
    if (this.testStep[i].type == 'MANUAL') {
      this.testStep[i].type = 'AUTOMATIC';
    }
    else {
      this.testStep[i].type = 'MANUAL';
    }
    ////this.testStep);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
      subscribe((data) => {
        if (data) {
          // ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                this.testStep = this.testStepdata.teststepList;

                for (let i = 0; i < this.testStep.length; i++) {

                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                  ////this.testStep);
                }
                this.visibleIndexForCardTip = this.testStep.length
                this.loadFlowchart(this.testStep);
                this.editEnable(this.testStep[i])
                this.loadTestStepData = false;
                this.getIncludedTestCases();
                this.toastrService.clear();
                this.toastrService.success(' changed Manual/Automatic successfully');

              }
            )
          //  this.testStepdata=data;
          //  this.router.navigate(['/TestStep/'+ this.projectId+ '/' +this.testId+ '/'+this.testStepId ]);
        }
      });
  }

  toggleAutomatic(i) {
    ////i);
    this.testStep[i].type = 'AUTOMATIC'

    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', this.testStepdata).
      subscribe((data) => {
        if (data) {
          // ////"upDateData", data);
          this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
            subscribe(
              (data) => {
                this.testStepdata = data;
                this.testStep = this.testStepdata.teststepList;

                for (let i = 0; i < this.testStep.length; i++) {

                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                  ////this.testStep);
                }
                this.visibleIndexForCardTip = this.testStep.length
                this.loadFlowchart(this.testStep);
                this.loadTestStepData = false;
                this.getIncludedTestCases();
                this.toastrService.clear();
                this.toastrService.success(' changed Manual/Automatic successfully');

              }
            )

        }
      });
  }

  onContextMenu(event: MouseEvent, testData, index, type) {
    if(this.hideCardIndex && this.cardView){
      this.toastrService.clear();
      this.toastrService.warning('More menu option not allowed, Expand view before any operation');
      return;
    }
    if(!this.enableEdit && this.cardView){
      this.toastrService.clear();
      this.toastrService.warning('More menu option not allowed, Cancel Edit Form then try to perform any Action');
      return;
    }
    
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': testData, 'index': index, 'type': type };
    // this.contextMenu.menuData = { 'index': index };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();

    ////testData,'onContext',this.contextMenu.menuData , '>>',index);
  }

  manageLocator(screenName, index) {

    //screenName, index, this.testStepCopy[index]['elementKey']);
    this.setting.seletedScreenName.next(this.testStepCopy[index]['elementKey']);
    this.project.getAllChildLocatorDir(this.projectId).subscribe(
      (data) => {

        if ($.isEmptyObject(data)) {
          this.toastrService.clear();
          this.toastrService.info('No locator is associated with this step');
          return;
        }
        this.testDataForManangeLocator = data['locatorSuite'].filter((f) => f.name == screenName);
        if (this.testDataForManangeLocator[0]) {
          this.project.sendLocatorDataFromTestStep(true);
          this._router.navigate(['/locator/' + this.projectId + '/' + this.testDataForManangeLocator[0].id],
            {
              queryParams:
              {
                index: index
              }
            });
        }
        else {
          this.toastrService.clear();
          this.toastrService.info('No locator is associated with this step');
        }
      }
    )
  }

  move(item, index) {
    ////item, index);
    this.StepMoveEnable = true;
    this.moveIndex = index;
    this.sourceIndex = this.moveIndex;

  }
  clear() {
    this.StepMoveEnable = false;
  }
  onMove() {
    ////'MovetestCase')

    this.submitted = true;
    if (this.moveTestStepForm.invalid) {
      return;
    }
    var objFormval = this.moveTestStepForm.value;

    this.orderIndex = (objFormval.orderIndex - 1).toString();
    ////this.orderIndex)
    if (this.orderIndex == this.sourceIndex) {
      this.toastrService.clear();
      this.toastrService.warning('source and destination index must not be same');
      return;
    }
    var lengthCheck = (this.testStep.length - 1).toString();
    if (this.orderIndex > lengthCheck) {
      this.toastrService.clear();
      this.toastrService.warning('index must not be out side the scope');
      return;
    }
    ////this.testStep.length);


    [this.testStep[this.sourceIndex], this.testStep[this.orderIndex]] = [this.testStep[this.orderIndex], this.testStep[this.sourceIndex]];

    //this.testStepdata);
    this.testCase.editTestCase(this.projectId, this.testId, this.testStepdata).subscribe((data) => {
      if (data) {
        ////"upDateData", data);
        if (this.cardView) {
          this.toastrService.clear();
          this.toastrService.success(' Card moved successfully');
        } else {
          this.toastrService.clear();
          this.toastrService.success(' Step moved successfully');
        }

        this.closeMoveModal.nativeElement.click();
        this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
          subscribe(
            (data) => {
              this.testStepdata = data;
              this.testStep = this.testStepdata.teststepList;

              for (let i = 0; i < this.testStep.length; i++) {

                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;
                ////this.testStep);
              }
              this.visibleIndexForCardTip = this.testStep.length
              this.loadFlowchart(this.testStep);
              setTimeout(() => {
                this.loadTestStepData = false;
                this.getIncludedTestCases();
              }, 0);

              // window.location.reload();

            }
          )

      }
    });
  }



  selectAll(event) {

    this.checkboxes.forEach((element) => {
      element.nativeElement.click();
      // this.checked_true=true;
      // this.checked_master=true;
    });

    this.checkAllTestSteps = event;
if(!this.cardView)
{
  this.testStepCopy.forEach(element => {
    element.checked = event;
    this.onChange(element.stepIndex, event);
  });
}   
else{
  this.testCopyFlowChart1.forEach(element => {
    element.checked = event;
    this.onChange(element.stepIndex, event);
  });

  this.loadFlowchart(this.testCopyFlowChart1)
} 
   
  }
  // getIncludedTestCases() {
  //   this.testCase.getIncludedTestCases(this.projectId).subscribe(
  //     (data) => {
  //       this.allTestCaseData = data['testCaseData'];
  //       localStorage.setItem('includedTestCase', JSON.stringify(this.allTestCaseData))
  //       this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId)
  //       for (let i = 0; i < this.testStepCopy.length; i++) {
            
  //         if (this.testStepCopy[i].commandName == 'INVOKETEST') {
  //           if (this.testStepCopy[i].parameters.settingValue.indexOf('&') == -1) {
  //             this.loadTestStepData = true;
  //             return;
  //           }
  //           this.testStepCopy[i].iteration = this.testStepCopy[i].parameters.settingValue.substr((this.testStepCopy[i].parameters.settingValue.indexOf('&') + 1), this.testStepCopy[i].length);

  //           var id = this.testStepCopy[i].parameters.settingValue.replace('&1','');
  //           this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == id);
  //           // this.testStepCopy[i].parameters.settingValue = this.testStepCopy[i].parameters.settingValue.substr(0, this.testStepCopy[i].parameters.settingValue.indexOf('&'));
  //           // this.testStepCopy[i].parameters.settingValue = this.getParameterName(this.testStepCopy[i].parameters.settingValue);
  //           this.testStepCopy[i].parameters.settingValue = this.filterStepDataForParam[0].path.replace(',', "").replaceAll(',', '/') + this.filterStepDataForParam[0].title;

      
  //           var inId = this.testStepCopy[i].parameters.settingValue.replace('&1','');
  //           this.testStepCopy[i].parameters.settingValue = this.testStepCopy[i].parameters.settingValue.substr(0, this.testStepCopy[i].parameters.settingValue.indexOf('&'));
  //           this.testStepCopy[i].parameters.settingValue = this.getParameterName(this.testStepCopy[i].parameters.settingValue);
  //           this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == inId);
  //           this.testCase.getTestSuiteData(this.projectId,this.filterStepDataForParam[0].parentTestDataId)
  //           .subscribe((data) => {
  //               console.log('data of suite parent ', data);
  //               this.testStepCopy[i].includeHref = '#/test/TestStep/'+this.projectId+'/'+data['id']+'/'+inId;
  //           })
  //           console.log('this.testStepCopy[i]', this.testStepCopy[i]);

  //         }
  //         else {
  //           this.loadTestStepData = true;
  //         }
  //       }
      
  //       // this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStepCopy));
  //     }
  //   )
  // }
  trimCommas(str) {
    return str.replace(/^,+|,+$/g, '');
}
invokeTestCaseHyperLinks:any={};
  getInvokedTestCaseLink(event: Event, path: string){
    event.preventDefault(); 
   var tempMetaData = this.invokeTestCaseHyperLinks[ path ];
  this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == tempMetaData.invokedTestCaseId);
  return this.testCase.getTestSuiteData(this.projectId,this.filterStepDataForParam[0].parentTestDataId)
  .subscribe((data) => {
      console.log('data of suite parent ', data);
      var  count=this.breadCrumb.length;
      this.breadCrumb = [];

          var breadCrumbObj = 
          {
            id:data['parentTestDataId'],
            title: this.trimCommas(data['path']),
            index: count++
          }
        this.breadCrumb.push(breadCrumbObj);
        // console.log('child',this.childModule);
        const ids = this.breadCrumb.map(({ title }) => title);
        var tempBreadCrumb = this.breadCrumb.filter(({ title }, index) =>
            !ids.includes(title, index + 1));
            localStorage.setItem('breadCrumb',JSON.stringify(tempBreadCrumb));
            this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
      return this._router.navigate(['/test/TestStep/'+tempMetaData.projectId+'/'+data['id']+'/'+tempMetaData.invokedTestCaseId], { replaceUrl: false });
  })};
  getIncludedTestCases() {
    this.testCase.getIncludedTestCases(this.projectId).subscribe(
      (data) => {
        this.allTestCaseData = data['testCaseData'];
        localStorage.setItem('includedTestCase', JSON.stringify(this.allTestCaseData))
        this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId);
        for (let i = 0; i < this.testStepCopy.length; i++) {
          if (this.testStepCopy[i].commandName == 'INVOKETEST') {
            if(this.testStepCopy[i].parameters.settingValue){
            if (this.testStepCopy[i].parameters.settingValue.indexOf('&') == -1) {
              this.loadTestStepData = true;
              return;
            }
            
            this.testStepCopy[i].iteration = this.testStepCopy[i].parameters.settingValue.substr((this.testStepCopy[i].parameters.settingValue.indexOf('&') + 1), this.testStepCopy[i].length);
            var inId = this.testStepCopy[i].parameters.settingValue.replace('&1','');
            this.testStepCopy[i].parameters.settingValue = this.testStepCopy[i].parameters.settingValue.substr(0, this.testStepCopy[i].parameters.settingValue.indexOf('&'));
            this.testStepCopy[i].parameters.settingValue = this.getParameterName(this.testStepCopy[i].parameters.settingValue);
            }
            if(this.invokeTestCaseHyperLinks[ this.testStepCopy[i].parameters.settingValue ]){
              // Ignore if the data already exist
          } else {
            this.invokeTestCaseHyperLinks[ this.testStepCopy[i].parameters.settingValue ] = {
              "projectId" : this.projectId,
              "invokedTestCaseId" : inId
            } ;
          }
          console.log('this.testStepCopy[i]', this.testStepCopy[i]);
        }
        else {
          this.loadTestStepData = true;
        }
      } 
      
        // this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStepCopy));
      }
    )
  }
  attachHitlBrnach(){
    this.testCase.getBranchList(this.projectId,this.testId).subscribe(
      (data)=>{
        this.allBranches = data;
        console.log(this.allBranches);
        var branchData = []
        for (let i = 0; i < this.testStepCopy.length; i++) {
          if (this.testStepCopy[i].commandName == 'HITL') {
            let element = this.testStepCopy[i]
            if (element.parameters.settingValue.length>10) {
              // console.log('firstparam' ,element.parameters.settingValue);
                
                  var branchIdArray = element.parameters.settingValue.split(",");
                  console.log('bArray',branchIdArray);
                  branchIdArray.forEach((element1,i)=> {
                   
                      branchData.push(this.retunBrnachName(element1))
                    
                  });
                  element.parameters.settingValue = branchData.join(',')
              return;
            }
          }
      }
    }
     )
  }
  getBranches(projectId,testSuiteId){
    this.testCase.getBranchList(projectId,testSuiteId).subscribe(
     (data)=>{
       this.allBranches = data;
       console.log(this.allBranches);
       
     }
    )
   }
   retunBrnachName(id){
    return this.allBranches.find((f)=>f.id==id).title
   }

  // getIncludedTestCases() {
  //   this.testCase.getIncludedTestCases(this.projectId).subscribe(
  //     (data) => {
  //       this.allTestCaseData = data['testCaseData'];
  //       localStorage.setItem('includedTestCase', JSON.stringify(this.allTestCaseData))
  //       this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId)
  //       for (let i = 0; i < this.testStepCopy.length; i++) {
            
  //         if (this.testStepCopy[i].commandName == 'INVOKETEST') {
  //           if (this.testStepCopy[i].parameters.settingValue.indexOf('&') == -1) {
  //             this.loadTestStepData = true;
  //             return;
  //           }
  //           this.testStepCopy[i].iteration = this.testStepCopy[i].parameters.settingValue.substr((this.testStepCopy[i].parameters.settingValue.indexOf('&') + 1), this.testStepCopy[i].length);

  //           //var id = this.testStepCopy[i].parameters.settingValue.replace('&1','');
  //           //this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == id);
  //            this.testStepCopy[i].parameters.settingValue = this.testStepCopy[i].parameters.settingValue.substr(0, this.testStepCopy[i].parameters.settingValue.indexOf('&'));
  //            this.testStepCopy[i].parameters.settingValue = this.getParameterName(this.testStepCopy[i].parameters.settingValue);
  //           this.testStepCopy[i].parameters.settingValue = this.filterStepDataForParam[0].path.replace(',', "").replaceAll(',', '/') + this.filterStepDataForParam[0].title;

      
  //           var inId = this.testStepCopy[i].parameters.settingValue.replace('&1','');
  //           this.testStepCopy[i].parameters.settingValue = this.testStepCopy[i].parameters.settingValue.substr(0, this.testStepCopy[i].parameters.settingValue.indexOf('&'));
  //           this.testStepCopy[i].parameters.settingValue = this.getParameterName(this.testStepCopy[i].parameters.settingValue);
  //           this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == inId);
  //           this.testCase.getTestSuiteData(this.projectId,this.filterStepDataForParam[0].parentTestDataId)
  //           .subscribe((data) => {
  //               console.log('data of suite parent ', data);
  //               this.testStepCopy[i].includeHref = '#/test/TestStep/'+this.projectId+'/'+data['id']+'/'+inId;
  //           })
  //           console.log('this.testStepCopy[i]', this.testStepCopy[i]);

  //         }
  //         else {
  //           this.loadTestStepData = true;
  //         }
  //       }
      
  //       // this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStepCopy));
  //     }
  //   )
  // }
  onChangeInvoke(id: string, isChecked: boolean) {

    if (isChecked) {
      //console.log(id);
      this.selectedCaseId = id;
      this.selectedCase = this.filterAllTesCaseData.filter((f => f.id == id))
      //console.log(this.selectedCase);
      this.moduleName = this.selectedCase[0].path.split(',');
    } else {

    }

  }
  // getIncludedTestCases(projectId) {//localStorage.setItem('includedTestCase',JSON.stringify(this.allTestCaseData))
  //   if(!JSON.parse(localStorage.getItem('includedTestCase'))){
  //     this.testCase.getIncludedTestCases(projectId).subscribe(
  //       (data) => {
  
  //         this.allTestCaseData = data['testCaseData'];
  //         this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId);
  //         //console.log('include', this.allTestCaseData);
  //         //console.log('filter>', this.filterAllTesCaseData);
  //         //console.log('data', this.testStep[this.testStepIndex - 1].parameters);
  //         if (this.testStep[this.testStepIndex - 1].commandName == 'INVOKETEST') {
  //           this.selectedTestCase = this.testStep[this.testStepIndex - 1].parameters['settingValue'].substr(0, this.testStep[this.testStepIndex - 1].parameters['settingValue'].indexOf('&'));
  //           //console.log('selectedId', this.selectedTestCase);
  //           if (this.selectedTestCase) {
  //             this.onChange(this.selectedTestCase, true)
  //           }
  //         }
  //       }
  //     )
  //   }
  //   else if(JSON.parse(localStorage.getItem('includedTestCase'))){
     
  //     this.allTestCaseData = JSON.parse(localStorage.getItem('includedTestCase'));
  //     this.filterAllTesCaseData = this.allTestCaseData.filter((f) => f.id != this.testStepId);
  //     //console.log('include', this.allTestCaseData);
  //     //console.log('filter>', this.filterAllTesCaseData);
  //     //console.log('data', this.testStep[this.testStepIndex - 1].parameters);
  //     if (this.testStep[this.testStepIndex - 1].commandName == 'INVOKETEST') {
  //       this.selectedTestCase = this.testStep[this.testStepIndex - 1].parameters['settingValue'].substr(0, this.testStep[this.testStepIndex - 1].parameters['settingValue'].indexOf('&'));
  //       //console.log('selectedId', this.selectedTestCase);
  //       if (this.selectedTestCase) {
  //         this.onChange(this.selectedTestCase, true)
  //       }
  //     }
  //   }
   
  // }
  getParameterName(id) {
    this.loadTestStepData = true;
    this.filterStepDataForParam = this.allTestCaseData.filter((f) => f.id == id);
   if(this.filterStepDataForParam && this.filterStepDataForParam.length>0){  
    return this.filterStepDataForParam[0].path.replace(',', "").replaceAll(',', '/') + this.filterStepDataForParam[0].title;
    }
    else {
      return id;
    }

  }

  filterParameter() {
    var count = 0;
    var countIf = 0;
    ////this.testStep);
    for (let i = 0; i < this.testStep.length; i++) {
      count++;
      if (this.testStep[i].commandName == 'INVOKETEST') {
        countIf++
        this.testStep[i].parameters = this.testStep[i].parameters.substr(0, this.testStep[i].parameters.indexOf('&'));

      }
      else {

      }
    }

  }


  newRequest = this.testCase.getRecordingStatus();

  getRecordingStatus() {
    return this.testCase.getRecordingStatus();
  }

  wrapMouseSequenceSteps(steps) {
    const mouseCommands = ['CLICK', 'JSCLICK', 'CONTEXTCLICK', 'MOUSEOVER', 'CHECK', 'UNCHECK', 'WAIT', 'WAITFORSHOW', 'MOVEANDCLICK'];
    const inner = (steps || []).filter((s) => {
      const name = (s && s.commandName) ? String(s.commandName).toUpperCase() : '';
      return mouseCommands.indexOf(name) !== -1;
    });
    const marker = (commandName) => ({
      active: "ENABLE",
      commandName: commandName,
      comment: "",
      elementKey: "",
      pageName: "",
      parameters: { fieldType: "", isMasked: "false", owner: "", settingType: "STANDARD", settingValue: "" },
      type: "AUTOMATIC"
    });
    return [marker('MOUSESEQUENCE')].concat(inner).concat([marker('ENDMOUSESEQUENCE')]);
  }

  inputBaseURL() {
    this.tabList = [];
    this.testCase.setEventData(undefined);
    this.testCase.setCopyStatus("NO");
    this.testCase.setRecordMode(null);
    this.newRequest = true;

    // Desktop uses same Record dialog options as Web (no Chrome extension).
    if (this.projectType === 'DESKTOP') {
      this.confirmationDialogService.openRecordDialog('Record', [], undefined, {
        projectType: 'DESKTOP',
        showMouseSequence: true
      }).afterClosed().subscribe((res) => {
        if (!res) {
          this.testCase.setRecordMode(null);
          return;
        }
        if (res.desktopMouseSequence || res.mode === 'MOUSE_SEQUENCE') {
          this.testCase.setRecordMode(null);
          this.toastrService.info('Use Windows Desktop Recorder in Mouse Sequence mode, then upload to this case.');
        } else {
          this.testCase.setRecordMode(null);
          this.toastrService.info('Record full desktop steps with Windows Desktop Recorder (UIRecorder), then reopen this case.');
        }
      });
      return;
    }

    for (let index = 0; index < 2; index++) {
      window.postMessage({
        type: "CHECK_IF_EXTENSION_INSTALLED"
      }, "*");
  
    }
   
      window.addEventListener("message", (event) => {
        if (event.data.type && event.data.type === "FROM_IF_EXTENSION_INSTALLED") {
          if (event.data.actions && event.data.actions === "version") {
            this.tabList = event.data.tabs;
            console.log('tablist',this.tabList);
            
            this.checkExtension = 2;
            ////"Receiving response and changing value");
          }
        } else if (event.data.type && event.data.type === "CHECK_IF_EXTENSION_INSTALLED") {
          this.checkExtension = 1;
        }
      });


    setTimeout(() => {
      if (this.checkExtension === 2) {
        this.confirmationDialogService.openRecordDialog('Record', this.tabList, undefined, {
          projectType: this.projectType
        }).afterClosed().subscribe(
          (res) => {
            if (!res) {
              this.testCase.setRecordMode(null);
              return;
            }
          }
        )
      } else if (this.checkExtension === 1) {
        this.testCase.setRecordMode(null);
        this.toastrService.info("Please refresh the browser (Ctrl+Shift+R) and try again if recorder is already loaded.");
      }
    }, 500);

  }

  stopRecording() {
    // Mouse Sequence inserts into the case — never wipe via overwrite dialog,
    // and never fire a second stop that clears captured actions to [].
    if (this.testCase.getRecordMode() === 'MOUSE_SEQUENCE') {
      this.testCase.setEventData(undefined);
      this.testCase.setRecordingStatus(false);
      this.newRequest = false;
      this.createRecordedData();
      return;
    }
    if (this.newRequest) {
      this.testCase.setEventData(undefined);
      this.testCase.setRecordingStatus(false);

      if (this.testStep == undefined) {
        this.testStep = [];
      }
      if (this.testStep.length > 0) {
        this.confirmationDialogService.stopRecordconfirmationDialog('Do you want to overwrite the whole script or create a new copy?').afterClosed().subscribe(
          (res) => {
            if (res) {
              this.testCase.setCopyStatus("YES");
              this.createRecordedData();
              // Do not call closeRecordedPage() here — it sends a second stop and clears actions.
            }
            else if (res == false) {
              ////'responce', res);
              this.testCase.setCopyStatus("NO");

              this.createRecordedData();
              // Do not call closeRecordedPage() here — it sends a second stop and clears actions.


              ////'copy');
            }
            else {
              this.closeRecordedPage();
            }
          }
        )


      }
      else {
        this.testCase.setCopyStatus("NO");
        this.createRecordedData();
      }
      this.newRequest = false;
    }
  };
  closeRecordedPage() {
    window.postMessage({
      type: "FROM_STOP_RECORD_PAGE_ONLY"
    }, "*");
  }

  createRecordedData() {
    var flag = false;
    ////"Web Page Send Stop Record Page Request");
    window.postMessage({
      type: "FROM_STOP_RECORD_PAGE"
    }, "*");

    window.addEventListener("message", (event) => {
      // if (dismissRecordingModel === 'dismiss') {
      //     return;
      // }
      // dismissRecordingModel = 'close';
      if (event.source !== window) {
        return;
      }
      else if (event.data.type && (event.data.type === "FROM_STOP_RECORD_PAGE_RESP")) {
        flag = false;

        var recordCommands = {};
        if (JSON.stringify(this.testCase.getEventData()) !== JSON.stringify(event.data)) {

          this.testCase.setEventData(JSON.parse(JSON.stringify(event.data)));
          ////event.data);

          flag = true;
          recordCommands['recordCommand'] = event.data.actions;
          var baseUrl = this.testCase.getRecordingUrl();
          var openCmd = "open";
          var eventCmd = "open";
          if (this.projectType === 'MIXED') {
            openCmd = "openBrowser";
            eventCmd = "openBrowser";
          }
          var openingCommand = {
            "actionType": openCmd,
            "eventName": eventCmd, "tagType": "NA",
            "type": "NA", "formAttrs": { "ID": "reg" },
            "tagAttrs": { "NAME": "browser" }, "tagContent": "f",
            "cssSelector": "#u_0_a", "tagPos": 0, "xpath": baseUrl
          };
          var filterCommands = {};
          filterCommands['recordCommand'] = new Array();
          var isFrame = false;
          var frameIndex = 0;
          var size = screen.width + "," + screen.height;
          if (this.testCase.getRecordMode() !== 'MOUSE_SEQUENCE') {
            filterCommands['recordCommand'].push(openingCommand);
          }
          ////filterCommands);

          if (recordCommands['recordCommand']) {
            for (var i = 0; i < recordCommands['recordCommand'].length; i++) {

              if (isFrame && (frameIndex === (i - 1))) {
                isFrame = false;
                filterCommands['recordCommand'][frameIndex + 1].xpath = recordCommands['recordCommand'][i].xpath;
                filterCommands['recordCommand'][frameIndex + 1].tagAttrs = recordCommands['recordCommand'][i].tagAttrs;
              }
              var command = {
                "actionType": recordCommands['recordCommand'][i].actionType,
                "eventName": recordCommands['recordCommand'][i].eventName,
                "tagName": recordCommands['recordCommand'][i].tagName,
                "tagType": recordCommands['recordCommand'][i].tagType,
                "type": recordCommands['recordCommand'][i].type,
                "formAttrs": recordCommands['recordCommand'][i].formAttrs,
                "tagAttrs": recordCommands['recordCommand'][i].tagAttrs,
                "cssSelector": recordCommands['recordCommand'][i].cssSelector,
                "tagPos": recordCommands['recordCommand'][i].tagPos,
                "xpath": recordCommands['recordCommand'][i].xpath,
                "tagContent": recordCommands['recordCommand'][i].tagContent,
                "xClient": recordCommands['recordCommand'][i].xClient,
                "yClient": recordCommands['recordCommand'][i].yClient,
                "screenSize": size
              };
              // filterCommands.recordCommand.push(command);
              filterCommands['recordCommand'].push(recordCommands['recordCommand'][i]);
              if ("Frame" === command.actionType || "selectwindow" === command.actionType) {
                // Use the Locator of the next step for this one
                isFrame = true;
                frameIndex = i;
                ////'filterCommands',filterCommands);

              }

            }

          }
          if (flag) {
            ////this.testIdForRecoder);
            var recordData = localStorage.getItem('testForRecoder');
            var projectIdForRecorder = localStorage.getItem('projectIdForRecoder');
            var taskIdForRecorder = localStorage.getItem('taskIdForRecorder');

            // Mouse Sequence must INSERT into the existing case, never wipe/replace it.
            if (this.testCase.getRecordMode() === 'MOUSE_SEQUENCE') {
              const rawActions = filterCommands['recordCommand'] || [];
              if (!rawActions.length) {
                this.testCase.setRecordMode(null);
                this.testCase.setRecordingStatus(false);
                this.closeRecordedPage();
                this.toastrService.info('No mouse actions were recorded (extension returned 0 events). Reload HuLoop extension (v3.0.1+), keep the target tab open while clicking, then Stop in Studio. Mouse Sequence does not show Overwrite — it inserts steps.');
                return;
              }
              const existingSteps = (this.testStepdata && this.testStepdata['teststepList'])
                ? JSON.parse(JSON.stringify(this.testStepdata['teststepList']))
                : (this.testStep ? JSON.parse(JSON.stringify(this.testStep)) : []);
              // Use same IDs / body shape as normal Record (filterCommands with recordCommand[]).
              const projectIdMs = projectIdForRecorder || this.projectId;
              const suiteIdMs = taskIdForRecorder || this.testId;
              const caseIdMs = recordData || this.testStepId;
              if (!projectIdMs || !suiteIdMs || !caseIdMs) {
                this.testCase.setRecordMode(null);
                this.testCase.setRecordingStatus(false);
                this.toastrService.error('Missing case ids for Mouse Sequence import. Re-open the case and try again.');
                return;
              }
              const finishMouseSequenceInsert = (translatedSteps: any[], locatorSuite?: any) => {
                const wrapped = this.wrapMouseSequenceSteps(translatedSteps || []);
                if (wrapped.length <= 2) {
                  this.testCase.setRecordMode(null);
                  this.testCase.setRecordingStatus(false);
                  this.closeRecordedPage();
                  this.toastrService.info('Recorded ' + rawActions.length + ' event(s), but none mapped to mouse commands. Existing steps were kept.');
                  return;
                }
                this.projectId = projectIdMs;
                this.testId = suiteIdMs;
                this.testStepId = caseIdMs;
                this.testStep = existingSteps.concat(wrapped);
                for (let i = 0; i < this.testStep.length; i++) {
                  this.testStep[i].stepIndex = i;
                  this.testStep[i].viewS = true;
                }
                if (!this.testStepdata) {
                  this.testStepdata = {};
                }
                this.testStepdata.teststepList = this.testStep;
                this.testCase.setRecordMode(null);
                this.testCase.editTestCase(this.projectId, this.testId, this.testStepdata).subscribe((saved: any) => {
                  const savedList = (saved && saved.teststepList) ? saved.teststepList : [];
                  const hasMarkers = savedList.some((s: any) => s && (s.commandName === 'MOUSESEQUENCE' || s.commandName === 'ENDMOUSESEQUENCE'));
                  if (!hasMarkers) {
                    this.toastrService.error('Saved steps lost MOUSESEQUENCE markers (became blank OPENBROWSER). Rebuild/restart Tomcat with updated CommandName.java, then record again.');
                  } else {
                    this.toastrService.clear();
                    this.toastrService.success('Mouse Sequence inserted. Existing steps were kept.');
                  }
                  // Save locators from preview when present (page/element keys).
                  const suite = Array.isArray(locatorSuite) ? locatorSuite[0] : locatorSuite;
                  if (suite && this.setting && typeof this.setting.editMultiLocatoSuite === 'function') {
                    this.setting.editMultiLocatoSuite(this.projectId, suite).subscribe(() => {}, () => {});
                  }
                  this.testStepCopy = JSON.parse(JSON.stringify(this.testStep));
                  this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStep));
                  this.closeRecordedPage();
                  this.reloadComponent();
                }, () => {
                  this.toastrService.error('Mouse Sequence translated but failed to save steps. If Tomcat is old, rebuild it with MOUSESEQUENCE support.');
                });
              };

              // Same payload shape as working saveRecordData path.
              this.testCase.getMidRecorderPreview(projectIdMs, suiteIdMs, caseIdMs, filterCommands).subscribe(
                (response: any) => {
                  const tcd = response && response.testCaseData;
                  const translated = (Array.isArray(tcd)
                    ? (tcd[0] && (tcd[0].teststepList || tcd[0].testStepList))
                    : (tcd && (tcd.teststepList || tcd.testStepList))) || [];
                  const locSuite = response && (response.locatorSuite || response.LocatorSuite);
                  finishMouseSequenceInsert(translated, locSuite);
                },
                (err: any) => {
                  // Fallback: append translated steps at end via mid-recorder upload, then wrap markers locally.
                  const insertAt = existingSteps.length;
                  this.testCase.saveMidRecorderData(projectIdMs, suiteIdMs, caseIdMs, 'NO', String(insertAt), filterCommands).subscribe(
                    () => {
                      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + projectIdMs + '/' + suiteIdMs + '/' + caseIdMs).subscribe(
                        (data: any) => {
                          const all = (data && data.teststepList) ? data.teststepList : [];
                          const newlyAdded = all.slice(insertAt);
                          // Remove bare appended steps, then re-insert wrapped block.
                          const before = all.slice(0, insertAt);
                          this.testStepdata = data;
                          this.testStep = before;
                          finishMouseSequenceInsert(newlyAdded);
                        },
                        () => {
                          this.testCase.setRecordMode(null);
                          this.testCase.setRecordingStatus(false);
                          this.toastrService.error('Failed to import Mouse Sequence after append. Existing steps may include unwrapped mouse steps — reload the case.');
                        }
                      );
                    },
                    () => {
                      this.testCase.setRecordMode(null);
                      this.testCase.setRecordingStatus(false);
                      const status = err && err.status ? (' HTTP ' + err.status) : '';
                      this.toastrService.error('Failed to import Mouse Sequence.' + status + ' Existing steps were kept.');
                    }
                  );
                }
              );
              return;
            }

            this.testCase.saveRecordData(projectIdForRecorder, taskIdForRecorder, recordData, filterCommands, this.testCase.getCopyStatus()).toPromise().then(
              (res) => {
                ////res);

                if (this.testCase.getCopyStatus() == 'NO') {

                  this.projectId = projectIdForRecorder;
                  this.testId = taskIdForRecorder;
                  this.testStepId = recordData;
                  this.testStepCopy = []
                 
                  this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {
            this.testStepdata = data;

            ////'testRecorder', this.testStepdata);

            if (this.testStepdata['teststepList']) {
              this.testStep = this.testStepdata['teststepList']
              for (let i = 0; i < this.testStep.length; i++) {

                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;
                ////this.testStep);
              }
              this.testStepCopy = JSON.parse(JSON.stringify(this.testStep))
              this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStep));
                  setTimeout(() => {
                    this.closeRecordedPage()
                    this.reloadComponent();
                    this.toastrService.clear();
                  this.toastrService.success('Case is created successfully');
                  }, 1500);
                 

                }
              })
            }
                if (this.testCase.getCopyStatus() == 'YES') {
                  this.toastrService.clear();
                  this.toastrService.success('Case copy created successfully with recorded steps');
                  this.closeRecordedPage()
                  
                }
                else{
                  this.toastrService.clear();
                  this.toastrService.success('Case is created successfully');
                }




                //'Test Case copy created successfully with recorded steps'
              }
            );


          }

        }
      }
    });

  }

  getInitTestSteptData() {
    setTimeout(() => {
      this.http.get(this.url + '/HuLoopRest/huloop/' + 'test/testCaseData/' + this.projectId + '/' + this.testId + '/' + this.testStepId).
        subscribe(
          (data) => {
            this.testStepdata = data;

            ////'testRecorder', this.testStepdata);

            if (this.testStepdata['teststepList']) {
              this.testStep = this.testStepdata['teststepList']
              for (let i = 0; i < this.testStep.length; i++) {

                this.testStep[i].stepIndex = i;
                this.testStep[i].viewS = true;
                ////this.testStep);
              }
              this.testStepCopy = JSON.parse(JSON.stringify(this.testStep))
              this.testCopyFlowChart = JSON.parse(JSON.stringify(this.testStep));

              var isLoopStarted = false;
              let ifConditionIndex;
              let endIfIndex;
              this.testStepCopy.forEach((element, i) => {
                if (element.commandName == 'IF') {
                  isLoopStarted = true;
                  ifConditionIndex = i + 1;
                }
                else if (element.commandName == 'ENDIF') {
                  isLoopStarted = false;
                  endIfIndex = i + 1;
                }
                // if(isLoopStarted){
                //  element['view']='horizontal'
                // }
                // else{
                //   element['view']='vertical'
                // }
              });

              let ifChildren = [];
              console.log("Flowchart :", ifConditionIndex, endIfIndex);
              ifChildren = this.testCopyFlowChart.slice(ifConditionIndex, endIfIndex);
              ifChildren.forEach((element) => {
                element['view'] = 'horizontal';
              })
              this.testCopyFlowChart.splice(ifConditionIndex, endIfIndex - ifConditionIndex);
              this.testCopyFlowChart.forEach((element, i) => {
                if (element.commandName == 'IF' || element.commandName == 'FOR') {
                  element['children'] = ifChildren;
                }
                element['view'] = 'vertical';
              })


              this.loadTestStepData = false;
              this.getIncludedTestCases();

            }
            else {
              this.testStepCopy = [];
            }

          }
        )

    }, 1000);

  }
  desableCardView() {
    this.testCase.setView(false)
    this.changeDefaultView(false);
    this.testCase.getView().subscribe(
      (data) => {
        this.cardView = data;
      }
    );
  }
  enableCardView() {
    this.getLocator();
    this.testCase.setView(true);
    this.changeDefaultView(true);
    this.testCase.getView().subscribe(
      (data) => {
        this.cardView = data;
      }
    );
  }
  collapseCard() {
    if (this.expandedView) {
      this.visibleIndex = []
      this.expandedView = false;
    }
    else {
      //$('#flexSwitchCheckDefault').is(':checked'));
      for (let index = 0; index < this.testStepCopy.length; index++) {
        if (!this.visibleIndex.includes(index)) {
          this.visibleIndex.push(index);
        }
      }
      this.expandedView = true;
    }


  }

  changeCardType() {
    this.cardViewType = this.cardViewType == 'Vertical' ? 'Horizontal' : 'Vertical';
    $('.hl-miniMap').removeClass('margin-left-horizontal-chart');
  }

  openSingleCard(i) {
    if (this.enableEdit === false) {
      return;
    }
    else if (this.enableEditForm == true) {
      this.enableEditForm == true
    }

    if ($('#flexSwitchCheckDefault').is(':checked')) {
      this.toastrService.clear();
      this.toastrService.warning('You have enabled Expanded View, Switch To Standard View ');
      return;
    }
    if (this.visibleIndex.length == 0) {
      this.visibleIndex.push(i);

    }

    if (this.visibleIndex.length > 0) {
      if (this.visibleIndex.includes(i)) {
        let index = this.visibleIndex.indexOf(i);
        delete this.visibleIndex[index]
      }
      else {
        this.visibleIndex[0] = i;
      }
    }
  }


  closeExpandedCard(i) {
    const index = this.visibleIndex.indexOf(i);
    this.visibleIndex.splice(index, i)
  }
  openToolTip(i) {

    this.openToolTipIndex = !this.openToolTipIndex
    this.visibleIndexForToolTip = i;

  }

  closeToolTip() {
    this.openToolTipIndex = false;
  }
  reloadComponent() {
    let currentUrl = this._router.url;
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this._router.onSameUrlNavigation = 'reload';
    this._router.navigate([currentUrl]);
  }

  allowDrop(event) {
    event.preventDefault();
    //event);

  }
  drag(commandName, action?: string, type?: string) {

    this.commandName = commandName
    this.actionType = type;
    if (action != 'action' && this.actionType == 'sub') {
      //action);
      this.subFunctionObject = action;
      this.subFunctionType = type;
      this.commandName = action['subname'];
      this.FunctionName = action['children'].name;
    }


  }
  drop(event, index) {
    event.preventDefault();
    //event, index);
    if (index > 0) {
      this.addFunctions(index, 'Add', this.commandName)
      // this.addBelow(index,'Add',this.commandName)
    }
    else {
      this.addRow(this.commandName);
    }

  }

  openGroupedAction(groupName) {
    this.groupNameDis = groupName
    this.clubbedActions = this.groupedActionData.filter((f) => f.groupName == groupName);
    this.actionsFilter = this.clubbedActions[0].children;
    $('.hl-chooseCatogeryWrapper').removeClass('show');
    $('.hl-actionWrapper').addClass('show');
    this.closemenu();
  }

  showSubfunctions(action) {
    //action);
    this.subFunctionType = action['type'];
    this.ActionName = action.name
    this.subFunctionsCollections = action.subfunction;
    this.subFunctionsCollections['type'] = action['type'];
    this.showSubFunctionFlag = !this.showSubFunctionFlag;
  }
  showDropdown() {
    this.showSubFunctionFlag = false;
    // $('.hl-actionWrapper').removeClass('show');
    // if(this.cardViewType == 'Horizontal')
    // {
    //   $('.hl-miniMap').addClass('margin-left-horizontal-chart');
    // }
    // $('.hl-chooseCatogeryWrapper').addClass('show');
    var x = document.getElementById("dropdown2");
    var y = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      $('.hl-chooseCatogeryWrapper').addClass('show');
      x.style.display = "block";
      y.style.display = "none";
    }

    else {
      x.style.display = "block";
    }
    this.globalSearch = undefined;
    this.searchAction();
  }

  scaleRatio = 1.0;

  getScale() {

    return `scale(${this.scaleRatio})`;
  }

  zoomIn() {
    if (this.scaleRatio > 1.5) {
      return;
    }
    //this.scaleRatio);
    this.scaleRatio += 0.1;
  }
  zoomOut() {
    if (this.scaleRatio < 0.5) {
      return;
    }
    this.scaleRatio -= 0.1;
  }
  reset() {
    this.scaleRatio = 1.0;
    //this.scaleRatio);

  }

  dragPosition = { x: 0, y: 0 };

  changePosition() {
    this.dragPosition = { x: this.dragPosition.x + 50, y: this.dragPosition.y + 50 };
  }
  encrypParameter(stepIndex) {
    var encryptObj = {
      projectId: this.projectId,
      id: this.testStepId,
      stepIndex: stepIndex
    }
    this.testCase.encryptTestStepParam(this.projectId, this.testStepId, stepIndex, encryptObj).subscribe(
      (data) => {
        this.testStepdata = data;

        this.toastrService.clear();
        this.toastrService.success('Parameter encrypted successfully')

        if (this.testStepdata['teststepList']) {
          this.testStep = this.testStepdata['teststepList']
          for (let i = 0; i < this.testStep.length; i++) {

            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;
            ////this.testStep);
          }
          this.visibleIndexForCardTip = this.testStep.length
          this.editEnable(this.testStep[stepIndex])
          this.loadFlowchart(this.testStep);
          this.loadTestStepData = false;
          this.getIncludedTestCases();
          

        }
        else {
          this.testStepCopy = [];
        }
      }
    )
  }

  enableRuntimeTestStep(stepIndex) {
    var runtimeObj = {
      projectId: this.projectId,
      id: this.testStepId,
      stepIndex: stepIndex
    }
    this.testCase.runtimeTestStep(this.projectId, this.testStepId, stepIndex, runtimeObj).subscribe(
      (data) => {
        this.testStepdata = data;
        var stepData = this.testStepdata['teststepList']
        console.log('stepData ', stepData);
        if(stepData[stepIndex].runtimeData==='true'){
          this.toastrService.clear();
          this.toastrService.success('Runtime parameter active')
        }else{
          this.toastrService.clear();
          this.toastrService.success('Runtime parameter deactive')
        }
        

        if (this.testStepdata['teststepList']) {
          this.testStep = this.testStepdata['teststepList']
          for (let i = 0; i < this.testStep.length; i++) {

            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;
            ////this.testStep);
          }
          this.visibleIndexForCardTip = this.testStep.length
          this.editEnable(this.testStep[stepIndex])
          this.loadFlowchart(this.testStep);
          this.loadTestStepData = false;
          this.getIncludedTestCases();

        }
        else {
          this.testStepCopy = [];
        }
      }
    )
  }

  decrypParameter(stepIndex) {
    var encryptObj = {
      projectId: this.projectId,
      id: this.testStepId,
      stepIndex: stepIndex
    }
    this.testCase.decryptTestStepParam(this.projectId, this.testStepId, stepIndex, encryptObj).subscribe(
      (data) => {
        this.testStepdata = data;

        this.toastrService.clear();
        this.toastrService.success('Parameter decrypted successfully')
        if (this.testStepdata['teststepList']) {
          this.testStep = this.testStepdata['teststepList']
          for (let i = 0; i < this.testStep.length; i++) {

            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;
            ////this.testStep);
          }
          this.visibleIndexForCardTip = this.testStep.length
          this.editEnable(this.testStep[stepIndex])
          this.loadFlowchart(this.testStep);
          this.loadTestStepData = false;
          this.getIncludedTestCases();

        }
        else {
          this.testStepCopy = [];
        }
      }
    )
  }

  showCommandName(command, param) {
    if (command != 'Set a Variable Value' && param?.length == 0) {
      // if (command.length > 10) {
      //   command = command.slice(0, 10) + '...'
      // }
      // return command;
      return this.actionsMetaData[command];
    }
    else if (command == 'Set a Variable Value' && param?.length > 0 && param?.includes('${_')) {

      param = param?.substring(0 + 4, param.indexOf("("));
      var functionName = this.functions.filter((f) => f.method == param)
      if (this.actionsMetaData[functionName[0].name]) {
        return this.actionsMetaData[functionName[0].name];
      } else {
        param = param?.substring(0 + 4, param?.indexOf("(")).slice(0, 10) + '...';
      }
      return param.toUpperCase();
    }
    else if (command == 'Set a Variable Value' && param?.length > 0 && !param?.includes('${_')) {
      return command.toUpperCase();
    }
    else if (command == 'Set a Variable Value' && param?.length == 0) {
      return command.toUpperCase();
    }
    else {

      return this.actionsMetaData[command];
    }
  }
  ShowTitle(command, param) {
    if (command != 'Set a Variable Value' && param?.length == 0) {

      return command

    }

    else if (command == 'Set a Variable Value' && param?.length > 0 && param?.includes('${_')) {

      return param?.substring(0 + 4, param?.indexOf("(")).toUpperCase();
    }
    else {

      return command;
    }
  }
  bindTitle(title) {
    if (title != 'sub') {
      return title;
    }
    else if (title == 'sub') {
      return 'Can not drag this , please click to expand and drag from the expanded';
    }
  }

  shouldHideChildren(id) {
    return this.treelistsvc.hideChildrenOfIds.includes(id);
  }

  hideChilren(i , testStep?:any,flag?:boolean) {
    // this.treelistsvc.hideNodeChilren(id);

    // this.shrinkArray = [];
    //     this.showIndex=i;
    var IfCount = 0
    var startIndex = 0;
    var endIndex = 0;
    if(testStep){
      // if(this.testStepCopy[i].commandName == 'IF'){
      //   startIndex = i;
      // }
      var getAllIfIndex = this.getAllIndexes(testStep, 'IF');
      var getAllEndIndex = this.getAllIndexes(testStep, 'ENDIF');
      // var getAllElseIfIndex = this.getAllIndexes(testStep, 'ELSEIF');
      // var getAllElseIndex = this.getAllIndexes(testStep, 'ELSE');
      //  if(getAllIfIndex.length == 1){
  //     if(getAllIfIndex.length>1){
  //       // testStep.forEach(element => {
  //       //   if(element.commandName == 'ENDIF'){}
  //       // });

  //       endIndex = testStep[getAllEndIndex[0]].stepIndex
  //     }

  //  else {

        endIndex = testStep[testStep.length-1].stepIndex
  //  }
        for (let z = i; z < endIndex; z++) {
         
          this.testStepCopy[z].viewS = !this.testStepCopy[z].viewS
          //   this.shrinkArray.push(i);
        }
        console.log('inner', this.testStepCopy , i);
        this.loadFlowchart(this.testStepCopy);
        this.hideCardIndex = !this.hideCardIndex;
        this.visibleIndexForCardTip = i;
        return;
    
     
      
    }
   
    


    for (let j = i; j < this.testStepCopy.length; j++) {
      this.testStepCopy[j].viewS = !this.testStepCopy[j].viewS
      //   this.shrinkArray.push(i);
    }
    this.loadFlowchart(this.testStepCopy);
    console.log(this.shrinkArray, this.testCopyFlowChart);

    this.hideCardIndex = !this.hideCardIndex;
    this.visibleIndexForCardTip = i;
    this.shrinkArray.push(i);
    console.log("working..", this.hideCardIndex, this.visibleIndexForCardTip);
    //this.visibleIndexForCardTip);

  }
  returnId(j) {
    if (j == 'IF') {
      return 'diamond'
    }
    else {
      return ''
    }
  }
  hideFlowChartChildren(i) {
    let className;
    if (this.cardViewType == 'Vertical') {
      if (this.hideCardIndex && i > this.visibleIndexForCardTip) {
        className = 'cardDisplay';
      }
    }
    else if (this.cardViewType == 'Horizontal') {
      className = 'd-flex';
      if (this.hideCardIndex && i > this.visibleIndexForCardTip) {
        className = 'cardDisplay';
      }
    }
    return className;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    this.contextMenu.closeMenu();
    // this.closeContext.nativeElement.click()
    // //"scrolling...",$event);
  }
  ngAfterViewInit() {
    if (this.selectedTestStep) {

      // this.reloadComponent();
      setTimeout(() => {
        document.getElementById(this.selectedTestStep).scrollIntoView({ behavior: 'smooth' });
        //"selectedTestStep", this.selectedTestStep);
        this.openSingleCard(this.selectedTestStep)

        // this.selectedTestStep = undefined;
      }, 3000)
    }
  }
  getCardColor(action, param, status?: string) {
    var skipColor = '#5497d5'
    var actionColor = '#39b54a';
    var action = action;
    var param = param;
    if (status == 'ENABLE') {
      this.groupedActionData.forEach((element, i) => {
        element.children.forEach((element1, j) => {
          if (element1.type == 'action' && element1.children.name == action) {
            // actionColor = element.groupColor;
          }
          if (element1.type == 'fun' && param.length > 0 && param.includes('${_') && element1.function) {
            var findFunction = this.functions.filter(f => (f.method == param.substring(0 + 4, param.indexOf("("))));
            if (element1.function.name == findFunction[0].name) {
              // actionColor = element.groupColor;
            }

          }
          if (element1.type == 'sub' && param.length > 0 && param.includes('${_') && element1.subfunction) {
            var findFunction = this.functions.filter(f => (f.method == param.substring(0 + 4, param.indexOf("("))));
            if (element1.subfunction[0].children.name == findFunction[0].name) {
              // actionColor = element.groupColor;
            }

          }

        });
      });
      return actionColor
    }
    else {
      return skipColor;
    }
  }

  getCardIcon(action, param) {
    var actionIcon;
    var action = action;
    var param = param;
    this.groupedActionData.forEach((element, i) => {
      element.children.forEach((element1, j) => {
        if (element1.type == 'action' && element1.children.name == action) {
          actionIcon = element.groupIcon;
        }
        if (element1.type == 'fun' && param?.length > 0 && param?.includes('${_') && element1?.function) {
          var findFunction = this.functions.filter(f => (f.method == param.substring(0 + 4, param.indexOf("("))));
          if (element1.function.name == findFunction[0].name) {
            actionIcon = element.groupIcon;
          }

        }
        if (element1.type == 'sub' && param?.length > 0 && param?.includes('${_') && element1?.subfunction) {
          var findFunction = this.functions.filter(f => (f.method == param.substring(0 + 4, param.indexOf("("))));
          if (element1.subfunction[0].children.name == findFunction[0].name) {
            actionIcon = element.groupIcon;
          }

        }

      });
    });
    return actionIcon
  }

  searchAction(value?:string) {
    // this.globalSearch;
    this.groupedActionDataCopy = JSON.parse(JSON.stringify(this.groupedActionData))
    this.groupedActionDataCopy1 = JSON.parse(JSON.stringify(this.groupedActionData))
    this.showSuggestion = true;
    //);
    if (this.globalSearch && this.globalSearch.trim().length === 0) {
      this.groupedActionDataCopy = this.groupedActionDataCopy1
      this.showSuggestion = false;
      return;
    }
    var searchArray = []
    this.groupedActionDataCopy.forEach((element, i) => {
      if (element.groupName.toLowerCase().includes(this.globalSearch.toLowerCase())) {

        searchArray.push(element);
      }
      element.children.forEach((element1, j) => {

        if (element1.type != 'sub') {
          if (element1.name.toLowerCase().includes(this.globalSearch.toLowerCase())) {

            searchArray.push(element1);
          }
        }
        if (element1.type == 'sub') {
          element1.subfunction.forEach(elementSub => {
            if (elementSub.name.toLowerCase().includes(this.globalSearch.toLowerCase())) {

              searchArray.push(elementSub);
            }
          });

        }
      });
    });
    if(value.trim().length>0){
      this.groupedActionDataCopy = this.urlService.removeDuplicates(searchArray);
    }
   else{
    this.groupedActionDataCopy = this.groupedActionDataCopy1;
   }


  }

  async mapActionPse(functions, actions) {
    console.log('functionData', this.functions);
    functions.forEach(functionPse => {
      if (this.actionsMetaData[functionPse.name]) {
        functionPse['pseFunction'] = this.actionsMetaData[functionPse.name]
      }
      else {
        functionPse['pseFunction'] = functionPse.name;
      }
    });

    actions.forEach(actionPse => {
      if (this.actionsMetaData[actionPse.name]) {
        actionPse['pseAction'] = this.actionsMetaData[actionPse.name]
      }
      else {
        actionPse['pseAction'] = actionPse.name
      }
    }
    )

    localStorage.setItem('actions', JSON.stringify(this.actions));
    localStorage.setItem('functions', JSON.stringify(this.functions));
  }
  openmenu() {
    var x = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      $('.hl-actionWrapper').removeClass('show');
      x.style.display = "block";

    }
    else {
      x.style.display = "block";
    }
  }
  closemenu() {
    var x = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      x.style.display = "block";
    }
    else {
      x.style.display = "none";
    }
  }

  switchMenu() {
    if (window.outerWidth <= 1024) {
      this.menuMobileShown = !this.menuMobileShown;
    } else {
      this.menuDesktopHidden = !this.menuDesktopHidden;
    }
    var element = document.getElementsByClassName("wrapper")[0];
    if (this.menuMobileShown) {
      element.classList.add("menu-mobile-shown");
    } else {
      element.classList.remove("menu-mobile-shown");
    }
    if (this.menuDesktopHidden) {
      element.classList.add("menu-desktop-hidden");
    } else {
      element.classList.remove("menu-desktop-hidden");
    }
  };

  switchMenu2() {
    if (window.outerWidth <= 1024) {
      this.menuMobileShown = !this.menuMobileShown;
    } else {
      this.menuDesktopHidden = !this.menuDesktopHidden;
    }
    var element = document.getElementsByClassName("wrapper")[0];
    if (this.menuMobileShown) {
      element.classList.add("menu-mobile-shown2");
    } else {
      element.classList.remove("menu-mobile-shown2");
    }
    if (this.menuDesktopHidden) {
      element.classList.add("menu-desktop-hidden2");
    } else {
      element.classList.remove("menu-desktop-hidden2");
    }
  };
  editEnable(testStep, index?: any, enableEdit?: boolean) {
   
    if(this.cardView){
    this.onRawClick();
    this.contentDiv[0]['result4']=[];
    this.selectedFunction = undefined;
    this.enableTextField = false;
    if(index>0){
      
    }
    // this.selectedCase = undefined;
    // this.selectedTestCase=undefined;
    this.contentDiv = [{
      "parameterType": undefined,
      "parameterValue": undefined
    }];
    this.optionSelected = [];
    this.objectForEditTestStep = undefined
    // this.objectForEditTestStep = undefined;
    // this.testStepUpdateForm.resetForm();
    if (testStep) {
      this.objectForEditTestStepCopy = JSON.parse(JSON.stringify(testStep));
     
      this.objectForEditTestStep = testStep;
      this.pseCommand = this.actionsMetaDataCopy[this.objectForEditTestStep.commandName]
      this.enableEdit = true;
      this.enableEditForm = false;
     
      if (enableEdit) {
        
        setTimeout(() => {
          console.log(this.stepTab.nativeElement.click());
        }, 0);
        // this.stepTab.nativeElement.click();
        this.enableEditForm = enableEdit
        this.enableEdit = false;
        if (this.objectForEditTestStep.commandName == 'INVOKETEST') {
          if (this.objectForEditTestStep.parameters.settingValue.indexOf('&') == -1) {
            this.loadTestStepData = true;
            return;
          }
          this.objectForEditTestStep.iteration = this.objectForEditTestStep.parameters.settingValue.substr((this.objectForEditTestStep.parameters.settingValue.indexOf('&') + 1), this.objectForEditTestStep.length);
          this.objectForEditTestStep.parameters.settingValue = this.objectForEditTestStep.parameters.settingValue.substr(0, this.objectForEditTestStep.parameters.settingValue.indexOf('&'));
          this.objectForEditTestStep.parameters.settingValue = this.getParameterName(this.objectForEditTestStep.parameters.settingValue);
          this.selectedTestCase = this.objectForEditTestStepCopy.parameters['settingValue'].substr(0, this.objectForEditTestStepCopy.parameters['settingValue'].indexOf('&'));
          //console.log('selectedId', this.selectedTestCase);
          if (this.selectedTestCase) {
            this.onChangeInvoke(this.selectedTestCase, true)
          }
  
        }
       

      }
      if (index == 0 || index > 0) {
        this.openSingleCard(index)
        this.stepIndexTobeEdit = index;
        this.performedAction = 'Add'
        this.enableEditForm = true;
        // this.objectForEditTestStepCopy = this.objectForEditTestStep
        if (this.objectForEditTestStep.commandName == 'INVOKETEST') {
          if (this.objectForEditTestStep.parameters.settingValue.indexOf('&') == -1) {
            this.loadTestStepData = true;
            return;
          }
          this.objectForEditTestStep.iteration = this.objectForEditTestStep.parameters.settingValue.substr((this.objectForEditTestStep.parameters.settingValue.indexOf('&') + 1), this.objectForEditTestStep.length);
          this.objectForEditTestStep.parameters.settingValue = this.objectForEditTestStep.parameters.settingValue.substr(0, this.objectForEditTestStep.parameters.settingValue.indexOf('&'));
          this.objectForEditTestStep.parameters.settingValue = this.getParameterName(this.objectForEditTestStep.parameters.settingValue);
          this.selectedTestCase = this.objectForEditTestStepCopy.parameters['settingValue'].substr(0, this.objectForEditTestStepCopy.parameters['settingValue'].indexOf('&'));
          //console.log('selectedId', this.selectedTestCase);
          if (this.selectedTestCase) {
            this.onChangeInvoke(this.selectedTestCase, true)
          }
  
        }
        this.enableEdit = false;
      }
      else {
        this.stepIndexTobeEdit = testStep.stepIndex;
        this.openSingleCard(this.stepIndexTobeEdit)
        this.performedAction = 'Edit'
        if (this.objectForEditTestStep.commandName == 'INVOKETEST') {
          if (this.objectForEditTestStep.parameters.settingValue.indexOf('&') == -1) {
            this.loadTestStepData = true;
            return;
          }
          this.objectForEditTestStep.iteration = this.objectForEditTestStep.parameters.settingValue.substr((this.objectForEditTestStep.parameters.settingValue.indexOf('&') + 1), this.objectForEditTestStep.length);
          this.objectForEditTestStep.parameters.settingValue = this.objectForEditTestStep.parameters.settingValue.substr(0, this.objectForEditTestStep.parameters.settingValue.indexOf('&'));
          this.objectForEditTestStep.parameters.settingValue = this.getParameterName(this.objectForEditTestStep.parameters.settingValue);
          this.selectedTestCase = this.objectForEditTestStepCopy.parameters['settingValue'].substr(0, this.objectForEditTestStepCopy.parameters['settingValue'].indexOf('&'));
          //console.log('selectedId', this.selectedTestCase);
          if (this.selectedTestCase) {
            this.onChangeInvoke(this.selectedTestCase, true)
          }
  
        }
      }
    }
  }
  }
  showInnerText() {
    this.showDetail = !this.showDetail;
    if (this.showDetail) {
      this.detailDesplay = 'block'
    }
    else {
      this.detailDesplay = 'none'
    }

  }
  manageParamOptions2 = ["Bugzilla", "GitLab", "Jira", "TFS", "TFS_PAT"];
  bugzilla = ["bugzilla_password", "bugzilla_url", "bugzilla_username", "type"];
  // bugZillaObjectForUpdate=[{"key":"bugzilla_password","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_url","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_username","value":"","$$hashKey":"object:6459"},{"key":"type","value":"","$$hashKey":"object:6459"},{"key":"bugzilla_password","value":"","$$hashKey":"object:6459"}]
  gitlab = ["gitlab_password", "gitlab_project", "gitlab_project_namespace", "gitlab_url", "gitlab_username"];
  jira = ["jira_password", "jira_project", "jira_url", "jira_userName"];
  tfs = ["tfs_metadata", "tfs_password", "tfs_project", "tfs_url", "tfs_username"];
  tfsPAT = ["tfs_metadata", "tfs_password", "tfs_project", "tfs_url", "tfs_username"];
  keys = ["NULL", "CANCEL", "HELP", "BACKSPACE", "TAB", "CLEAR", "RETURN", "ENTER", "SHIFT", "LEFT_SHIFT", "CONTROL", "LEFT_CONTROL", "ALT", "LEFT_ALT"
    , "PAUSE", "ESCAPE", "SPACE", "PAGE_UP", "PAGE_DOWN", "END", "HOME", "LEFT", "ARROW_LEFT", "UP", "ARROW_UP", "RIGHT", "ARROW_RIGHT", "DOWN"
    , "ARROW_DOWN", "INSERT", "DELETE", "SEMICOLON", "EQUALS", "F1", "F2", "F3", "F4", "F5", "F6"];
  keyValueFunctions = ["extraction","redaction","filehandle", "pdfHandle", "dataCompare", "getJsonValue", "sqlDump", "getXmlValue", "ntlmtoken", "oauthtoken", "jsonCompare", "deletefile", "verifytext", "watchfile", "copyfile", "loadcsv", "couchbasesql", "filevalidate", "loadtestData", "wordEmbedded", "pdfmerge", "getCellReference", "setCellReference", "loadExcelTable", "excelHandle", "runCmdProcess", "csvvalidate", "getColumnSumExcel","csvHandle"];
  contentDiv = [{
    "parameterType": undefined,
    "parameterValue": undefined
  }];
  showDiv = {
    previous: false,
    current: false,
    next: false
  }
  onRawClick() {
    if (this.rawclicked == false) {
      this.showDiv.previous = !this.showDiv.previous;
      this.showDiv.current = false;
      this.showDiv.next = false;
      this.rawclicked = true;
      this.formclicked = false;
    }
    this.selectChangeHandler('Text', 0);
  }
  addParameter() {
    // return;
    this.contentDiv.push({
      "parameterType": undefined,
      "parameterValue": undefined
    });
  }
  onFormClick() {
    if (this.formclicked == false) {
      this.showDiv.current = !this.showDiv.current;
      this.showDiv.previous = true;
      this.showDiv.next = false;
      this.rawclicked = false;
      this.formclicked = true;
    }
    var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
    // this.testStepUpdateForm.reset();
    // this.contentDiv = [{
    //   "parameterType": undefined,
    //   "parameterValue": undefined
    // }];
    console.log('form',this.testStepUpdateForm , 'content', this.contentDiv);
    this.contentDiv[0]['result4']=[];
    this.segregateParameters(this.objectForEditTestStep.parameters['settingValue']);

    if (this.objectForEditTestStep.parameters['settingValue'].includes('{')) {
      this.parameterValueForUpdate = this.objectForEditTestStep.parameters['settingValue'].split('}');

      //console.log(this.parameterValueForUpdate);
      var indexCheck: boolean = false;
      var funCheck: boolean = false;
      for (let i = 0; i < this.parameterValueForUpdate.length; i++) {
        if (this.parameterValueForUpdate.length > 1) {

          if (this.parameterValueForUpdate[i].includes('${_')) {
            funCheck = true;
            if (indexCheck) {
              this.addParameter();
            }
            if (this.enableTextField) {
              this.addParameter();
            }


            for (let j = 0; j < this.functionDataForUpdate.length; j++) {
              this.contentDiv[0]['fieldlist'][j]['value'] = this.functionDataForUpdate[j]

            }

          }

        }

      }

    }
    else {

      if (funCheck) {
        this.addParameter();
      }
      if (indexCheck) {
        this.addParameter();
      }
      this.enableTextField = true;
      this.optionSelected.push('Text');
      this.selectChangeHandler('Text', 0);
      this.textParameter = this.objectForEditTestStep.parameters['settingValue'];
      this.contentDiv[0].parameterValue = this.textParameter;
    }
  }
  segregateParameters = function (input) {
    var paramValue = input;
    var func = "${__";
    var globalVar = "$G{";
    var localeVar = "$L{";
    var suiteVar = "$S{";
    var localVar = "${";
    var endVar = "}";
    var endFunc = ")}";
    var n = 0;
    var showDropdown = false;
    var parametersFormsSequence = new Array();
    var groups = {};
    groups[func] = endFunc;
    groups[globalVar] = endVar;
    groups[localeVar] = endVar;
    groups[suiteVar] = endVar;
    groups[localVar] = endVar;

    var arguments1 = {};
    var argumentIndex = 0;
    var increaseArgIndex = false;

    for (var i = 0; i < paramValue.length; i++) {
      if (paramValue.charAt(i) === '$') {
        if (func === paramValue.substring(i, i + 4)) {
          argumentIndex++;
          n = paramValue.indexOf(endFunc, i);
          arguments1[argumentIndex] = {};
          parametersFormsSequence.push(arguments1[argumentIndex]);
          //console.log(parametersFormsSequence);

          arguments1[argumentIndex].name = paramValue.substring(i + 4, paramValue.indexOf("(", i));
          arguments1[argumentIndex].type = "Function";
          // arguments1[argumentIndex].form =this.evaluateParamTemplate({type: arguments[argumentIndex].name});
          arguments1[argumentIndex].data1 = (paramValue.substring(i, n + 2));
          arguments1[argumentIndex].args = (arguments1[argumentIndex].data1.substring(arguments1[argumentIndex].data1.indexOf("(") + 1, arguments1[argumentIndex].data1.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //console.log('Args', arguments1[argumentIndex].args);
          //console.log('name', arguments1[argumentIndex].name);
          var selectedFunction = this.functions.filter((f) => f.method === arguments1[argumentIndex].name)
          this.optionSelected.push('Function');
          // //console.log('selectedFunction', selectedFunction);

          // this.selectBox.nativeElement.click();
          this.selectChangeHandler('Function', 0);
          this.selectedFunction = selectedFunction[0].pseFunction;
          this.selectfunctionHandler(selectedFunction[0].name, 0);
          this.functionDataForUpdate = arguments1[argumentIndex].args;
          //console.log(this.functionDataForUpdate);

          if (this.checkIfFunctionMethodNameExist(arguments1[argumentIndex].name) && n >= 0) {
            if (this.keyValueFunctions.includes(arguments1[1].name) || this.currentFunction.isKeyValueFunction) {
              var value = '';
              var activeFieldList = new Array();
              for (var k = 0; k < this.currentFunction.fieldList.length; k++) {
                if (this.currentFunction.fieldList[k].isVisible == true) {
                  activeFieldList.push(this.currentFunction.fieldList[k]);
                }
              }
              for (var j = 0; j < arguments1[argumentIndex].args.length; j++) {
                var data = arguments1[argumentIndex].args[j].split(/=(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                if (j === 0) {
                  value = data[1];
                  // this.contentDiv[0]['fieldlist'][j]['value']=data[1];
                  //console.log(this.contentDiv[0]);

                }
                if (activeFieldList.length > j) {
                  var matchingField = this.getFuntionField1(activeFieldList, data[0]);
                  /**
                   * If field is drop down then we will be adding all the dependent fields on the matching active field list.
                   */
                  if (matchingField && matchingField.type === 'dropdown') {
                    var matchingValues = this.getMatchingValues(this.getMatchingFields(this.currentFunction.fieldList, data[0]), data[1]);
                    for (var k = 0; k < matchingValues.length; k++) {
                      if (!this.getFuntionField1(activeFieldList, matchingValues[k].name)) {
                        activeFieldList.push(matchingValues[k]);
                      }
                      //console.log(activeFieldList);

                    }
                  }
                  arguments1[argumentIndex].args[j] = data[1];
                  //console.log(arguments1[argumentIndex]);

                  // this.contentDiv[0]['fieldlist'][j]['value']=data[1];
                } else if (this.currentFunction.variableFieldList && activeFieldList.length > 0) {
                  var fields = data[0].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                  var fieldObject = new Object();
                  for (var k = 0; k < fields.length; k++) {
                    if (fields[k] !== undefined && fields[k].length > 0) {
                      fieldObject[k] = fields[k];
                    }
                  }
                  arguments1[argumentIndex].args[j] = fieldObject;
                  //console.log(arguments1[argumentIndex]);

                }
              }
              this.onChangeFunctionDropdown(value, this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable, 0);
            } else if (arguments1[1].name === "exeexecute") {
              arguments1[argumentIndex].args = (arguments1[argumentIndex].data.substring(arguments1[argumentIndex].data1.indexOf("(") + 1, arguments1[argumentIndex].data1.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
            } else {
              if (this.currentFunction.type === 'variable') {
                for (let j = this.currentFunction.fieldList.length; j < arguments1[argumentIndex].args.length; j++) {
                  var fields = arguments1[argumentIndex].args[j].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                  var fieldObject = new Object();
                  for (var k = 0; k < fields.length; k++) {
                    if (fields[k] !== undefined && fields[k].length > 0) {
                      fieldObject[k] = fields[k];
                    }
                  }
                  arguments1[argumentIndex].args[j] = fieldObject;
                  // if(j>0){
                  //   this.addVariableFields(this.currentFunction.name,0,arguments1[argumentIndex].args[j][0])
                  // }

                }
              }
              console.log(arguments1[argumentIndex].args);
              for (let z = 1; z < arguments1[argumentIndex].args.length; z++) {

                this.addVariableFields(this.currentFunction.name, 0, arguments1[argumentIndex].args[z][0])


              }
              this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable, 0);
            }

            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/function.html';
            i = n + 1;
            increaseArgIndex = true;
          } else {
            this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name);
            arguments1[argumentIndex].name = "";
            arguments1[argumentIndex].type = "Text";
            arguments1[argumentIndex].data = (paramValue.substring(i));
            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/text.html';
            break;
          }

          //           if (this.checkIfFunctionMethodNameExist(arguments1[argumentIndex].name) && n >= 0) {
          //             if (this.keyValueFunctions.includes(arguments1[1].name) || this.currentFunction.isKeyValueFunction) {
          //                 var value = '';
          //                 var activeFieldList = new Array();
          //                 for (var k = 0; k < this.currentFunction.fieldList.length; k++) {
          //                     if (this.currentFunction.fieldList[k].isVisible == true) {
          //                         activeFieldList.push(this.currentFunction.fieldList[k]);
          //                     }
          //                 }
          //                 for (var j = 0; j < arguments1[argumentIndex].args.length; j++) {
          //                     var data = arguments1[argumentIndex].args[j].split(/=(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //                     if (j === 0) {
          //                         value = data[1];
          //                         // this.contentDiv[0]['fieldlist'][j]['value']=value;
          //                         //console.log(this.contentDiv[0]['fieldlist']);

          //                     }
          //                     if (activeFieldList.length > j) {
          //                         var matchingField = this.getFuntionField1(activeFieldList, data[0]);
          //                         /**
          //                          * If field is drop down then we will be adding all the dependent fields on the matching active field list.
          //                          */
          //                         if (matchingField && matchingField.type === 'dropdown') {
          //                             var matchingValues = this.getMatchingValues(this.getMatchingFields(this.currentFunction.fieldList, data[0]), data[1]);
          //                             for (var k = 0; k < matchingValues.length; k++) {
          //                                 if (this.getFuntionField1(activeFieldList, matchingValues[k].name)) {
          //                                     activeFieldList.push(matchingValues[k]);
          //                                 }

          //                             }
          //                         }
          //                         arguments1[argumentIndex].args[j] = data[1];
          //                         this.contentDiv[0]['fieldlist'][j]['value']=data[1];
          //                         //console.log(this.contentDiv[0]['fieldlist']);

          //                     } else if (this.currentFunction.variableFieldList && activeFieldList.length > 0) {
          //                         var fields = data[0].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //                         var fieldObject = new Object();
          //                         for (var k = 0; k < fields.length; k++) {
          //                             if (fields[k] !== undefined && fields[k].length > 0) {
          //                                 fieldObject[k] = fields[k];
          //                             }
          //                         }
          //                         arguments1[argumentIndex].args[j] = fieldObject;
          //                     }
          //                 }
          //                 this.onChangeFunctionDropdown(value, this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
          //             } else if (arguments1[1].name === "exeexecute") {
          //                 arguments1[argumentIndex].args = (arguments1[argumentIndex].data.substring(arguments1[argumentIndex].data.indexOf("(") + 1, arguments1[argumentIndex].data.lastIndexOf(")"))).split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //             } else {
          //               if(this.currentFunction.type === 'variable') {
          //                   for(let j = this.currentFunction.fieldList.length;j<arguments1[argumentIndex].args.length;j++){
          //                       var fields = arguments1[argumentIndex].args[j].split(/:(?=(?:(?:[^"]*"){2})*[^"]*$)/);
          //                       var fieldObject = new Object();
          //                       for (var k = 0; k < fields.length; k++) {
          //                         if (fields[k] !== undefined && fields[k].length > 0) {
          //                                   fieldObject[k] = fields[k];
          //                               }
          //                       }
          //                       arguments1[argumentIndex].args[j] = fieldObject;
          //                   }
          //               }
          //                 this.onChangeFunctionDropdown(arguments1[argumentIndex].args[0], this.currentFunction.fieldList[0].name, this.currentFunction.fieldList[0].isFieldDecideable,0);
          //             }
          // //console.log(this.contentDiv);

          //             // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/function.html';
          //             i = n + 1;
          //             increaseArgIndex = true;
          //         }
        }
        else if (globalVar === paramValue.substring(i, i + 3)) {
          argumentIndex++;
          n = paramValue.indexOf(endVar, i);
          arguments1[argumentIndex] = {};
          parametersFormsSequence.push(arguments1[argumentIndex]);
          if (n >= 0) {
            arguments1[argumentIndex].type = "Global Variable";
            arguments1[argumentIndex].data = (paramValue.substring(i, n + 1));
            arguments1[argumentIndex].value = (paramValue.substring(i + 3, n));
            //console.log('Global,',arguments1[argumentIndex].data)
            // arguments1[argumentIndex].template = 'modules/test/partials/modal/teststep/variable.html';
            i = n;
            increaseArgIndex = true;
            this.selectChangeHandler('Global Variable', 0);
            // this.globalVariableForUpdate = this.parameterValueForUpdate[i].slice(this.parameterValueForUpdate[i].indexOf('{') + 1, this.parameterValueForUpdate[i].length);
            this.optionSelected.push('Global Variable');
            this.selectedGlobalVar = this.globalVariableForUpdate = arguments1[argumentIndex].value;
            //console.log(this.globalVariableForUpdate);
            //console.log(this.contentDiv.length, this.contentDiv);

            this.selectedGVar(this.globalVariableForUpdate, 0)
          } else {
            arguments1[argumentIndex].type = "Text";
            arguments1[argumentIndex].data = (paramValue.substring(i));
            // arguments[argumentIndex].template = 'modules/test/partials/modal/teststep/text.html';
            break;
          }

        }
      }
    }



  };


  selectfunctionHandler(event: any, index, identifier?: string) {
    console.log(event, index);
    this.contentDiv[0]['result4']=[];
    if (identifier) {
      var functionName = this.functions.find((f) => f.pseFunction == event)
      if (functionName) {
        this.contentDiv[index].parameterValue = functionName.name;
        this.selectedfValue = functionName.name;
      }
      else {
        this.contentDiv[index].parameterValue = event;
        this.selectedfValue = event;
      }
    }
    else {
      this.contentDiv[index].parameterValue = event;
      this.selectedfValue = this.contentDiv[index].parameterValue;
    }

    // if(this.testStep[this.testStepIndex-1].parameters.includes('$')){
    //   this.contentDiv[index]['result1'][0]=this.functionDataForUpdate;
    // this.contentDiv[index]['result1']=this.contentDiv[index]['result1'];
    // }
    this.valuechanged = true;
    const funcData = this.functions.filter((f) => f.name === this.selectedfValue);
    this.currentFunction = funcData[0];
    // console.log(this.currentFunction);

    this.contentDiv[index]['type'] = [];
    this.contentDiv[index]['type'] = funcData[0].type;
    // this.contentDiv[index]['fieldlist'] = []
    this.contentDiv[index]['fieldlist'] = funcData[0].fieldList;
    this.currentFunction.fieldList = this.contentDiv[index]['fieldlist']
    // console.log(this.currentFunction);

    this.contentDiv[index]['methodname'] = []
    this.contentDiv[index]['methodname'] = funcData[0].method;
    this.contentDiv[index]['isKeyValueFunction'] = funcData[0].isKeyValueFunction;
    for (var i = 0; i < this.contentDiv[index]['fieldlist'].length; i++) {
      if (this.contentDiv[index]['fieldlist'][i].defaultValueType === 'dynamic') {
        this.getDynamicData(this.contentDiv[index]['methodname'], this.projectId, this.contentDiv[index]['fieldlist'][i]);
      }
    }



  }
  getDynamicData(methodName, projectId, field) {
    this.testCase.getdynamicDropDownData(methodName, projectId).subscribe(
      (data: any) => {

        if (!Array.isArray(data.list)) {
          field.defaultValues = ''
          field.defaultValues = ['', data.list];
        }
        else {
          field.defaultValues = data.list;
          field.defaultValues.unshift(' ');
        }

      }
    )
  }
  addVariableFields(selectedFunction: string, index1, value?: string) {
    // this.contentDiv[index1]['result4']=[]
    this.functions.forEach(element => {
      if (element.name == selectedFunction) {
        if (element.variableFieldList) {
          console.log(element.variableFieldList)
          if (this.contentDiv[index1]['result4'] == undefined) {
            this.contentDiv[index1]['result4'] = [];
          }
          if (value) {
            element.variableFieldList[0].value = value;
          }
          if (value == undefined) {
            element.variableFieldList[0].value = '';
          }

          let valArray = [];

          valArray.push(JSON.parse(JSON.stringify(element['variableFieldList'])));

          
          this.contentDiv[index1]['result4'].push(...JSON.parse(JSON.stringify(valArray)));



        }
      }
    });
    // console.log('result$', this.contentDiv[index1]['result4']);

  }
  deleteVField(index) {
    this.contentDiv[0]['result4'].splice(index, 1);
    console.log(this.contentDiv[0]['result4']);

  }
  myFunction(contentIndex) {
    this.contentDiv[contentIndex]['result2'] = [];
    //console.log(contentIndex);

  }
  selectfunctionValues(event: any, index, fieldName = "", isDecidable: boolean = false) {

    if (fieldName != '') {
      //console.log("inside if")
      let obj = { name: fieldName, value: event };
      this.contentDiv[index]['result3'] = [];
      this.contentDiv[index]['result3'].push(obj);
    }
    if (event.includes(' ')) {
      //console.log(event);
      this.eventwithoutSpace = event.replace(/\s/g, "")
      event = this.eventwithoutSpace;
    }
    this.contentDiv[index]['result'] = [];
    this.contentDiv[index]['result'] = event;
    this.contentDiv[index]['result2'] = [];
    this.contentDiv[index]['parameterArg'] = event;
    this.selectedFunctionValues = event;
    //console.log(this.selectedFunctionValues);
    if (!isDecidable) {
      return;
    }
    this.contentDiv[index]['Vfield'] = this.getFuntionField(this.contentDiv[index]['fieldlist'], this.selectedFunctionValues);
    // this.contentDiv[index]['Vfield'] = this.contentDiv[index]['Vfield'].filter(function (e) { return e != null; });

  }

  keyArray(value) {
    this.selectedKeys = [];
    this.selectedKeys.push(value);
    //console.log(this.selectedKeys);
  }
  onItemSelect(item: any) {
    // this.selectedKeys=[];
    //console.log('onItemSelect', item);
    this.selectedKeys.push(item);
    //console.log(this.selectedKeys)
  }
  onItemDeSelect(item: any) {
    var index = this.selectedKeys.indexOf(item);
    if (index !== -1) {
      this.selectedKeys.splice(index, 1);
    }
    //console.log(item);
    //console.log(this.selectedKeys);

  }
  onSelectAll(item: any) {
    //console.log('onSelectAll', item);
  }



  getElementKey(pageName) {
    //console.log(pageName);
    this.elementKeyData = this.locatorData.filter((s) => s.name === pageName); //imp
    //console.log('elementKeyData', this.elementKeyData, pageName)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    // this.project.getProjectById(this.projectId).subscribe((
    //   data => {
    //     this.projectData = data;
    //     //console.log(this.projectData);
    //     this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
    //       (data) => {
    //         this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
    //           //console.log(data);
    //         })
    //         this.locatorValueData = data;
    //         //console.log(this.locatorValueData);
    //         // if(this.locatorValueData.locatorEntryMap==null){
    //         //   this.locatorEntryMapValue = {entry:[]} ;
    //         //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         // }
    //         // if(this.locatorValueData.locatorEntryMap!=null){
    //         //   this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         //   this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
    //         // }
    //         this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
    //         //console.log(this.locatorEntryMapValue);
    //         this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
    //       }
    //     )
    //   }
    // ))

    this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    //console.log(this.elementEntryKeyData);
  }
  saveChange(testStepUpdateForm) {
    console.log(testStepUpdateForm);
    this.testStepAtSelectedIndex = this.objectForEditTestStep;
    this.arr = testStepUpdateForm.value;
    this.arr.action
    console.log('arr', this.arr);
    //console.log(this.arr.Action)
    //console.log(this.actions);
    var FilterCommandName = this.actions.filter(f => f.pseAction == this.arr.Action || f.name == this.arr.Action);
    if (FilterCommandName[0]) {
      this.arr.Action = FilterCommandName[0].name
    }
    else {
      //console.log('includes');
      this.toastrService.clear();
      this.toastrService.warning('Select command from the dropdown')
      return;
    }

    if (this.testStepAtSelectedIndex) {
      if (this.arr.actOptions) {
        this.testStepAtSelectedIndex.commandName = this.arr.actOptions;
      }
      else {
        this.testStepAtSelectedIndex.commandName = this.arr.Action;

      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.pageName = this.arr.screenOptions;


        var testScreen = this.locatorData.filter((f) => f.name == this.testStepAtSelectedIndex.pageName);
        //console.log(testScreen);
        if (this.testStepAtSelectedIndex.pageName && testScreen.length < 1) {
          this.toastrService.clear();
          this.toastrService.warning('Select valid name from the dropdown');
          return;
        }
      }
      else {
        this.testStepAtSelectedIndex.pageName = this.arr.Screen;
        var testScreen;
        if (this.locatorData) {
          testScreen = this.locatorData.filter((f) => f.name == this.testStepAtSelectedIndex.pageName);
        }

        if (this.testStepAtSelectedIndex.pageName && testScreen && testScreen.length < 1) {
          this.toastrService.clear();
          this.toastrService.warning('Select valid name from the dropdown');
          return;
        }
      }
      if (this.arr.screenOptions) {
        this.testStepAtSelectedIndex.elementKey = this.arr.screenOptions;
      }

      this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
      // //console.log(this.selectedValue);

    }
    if (this.selectedValue === 'Text') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.arr.Parameter;
    }
    if (this.selectedAction === 'SEND_KEYS' || this.arr.Action == 'SEND_KEYS') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedKeys.toString() + '&' + this.arr.Parameter;
    }
    if (this.selectedAction === 'INVOKETEST' || this.arr.Action=='INVOKETEST' || this.selectedAction === 'RUN_STEP_BATCH' || this.selectedAction === 'RUNTESTDATA') {
      if(this.selectedCase){
        this.testStepAtSelectedIndex.parameters['settingValue'] = this.selectedCaseId + '&' + this.selectedCase[0].execuationIteration;
      }
     else{
      this.toastrService.clear();
      this.toastrService.warning('Select any case from the list');
      return;
     }
      //console.log(this.testStepAtSelectedIndex.parameters);

    }
    // if (this.selectedAction === 'SET_BUG_LOG_DATA') {
    //   this.testStepAtSelectedIndex.parameters['settingValue'] = JSON.stringify(this.parameterForLogData);
    // }
    if (this.selectedValue === 'Global Variable') {
      this.testStepAtSelectedIndex.parameters['settingValue'] = '$G{' + this.arr.globalValue + '}';

    }

    if (this.selectedValue === 'Function') {
      //console.log(this.arr);
      var functionValue = _.omit(this.arr, ['Action', 'actOptions', 'Screen', 'screenOptions', 'Element', 'elementKey']);
      //console.log(functionValue);

      const myArray = Object.values(functionValue);
      //console.log(myArray);

      // this.testStepAtSelectedIndex.parameters = '${__' + this.contentDiv[index]['methodname'] + '(' + myArray + ')' + '}';
    }
    if (!this.selectedValue) {
      this.testStepAtSelectedIndex.parameters['settingValue'] = this.testStepAtSelectedIndex.parameters['settingValue'];
    }
    if (this.contentDiv && this.selectedValue == 'Function' || this.selectedValue == 'Global Variable') {
      //console.log(this.contentDiv);

      var paramName = '';
      for (let i = 0; i < this.contentDiv.length; i++) {

        if (this.contentDiv[i].parameterType == 'Text') {
          paramName = paramName + this.contentDiv[i].parameterValue;

        }
        if (this.contentDiv[i].parameterType == 'Global Variable') {
          paramName = paramName + '$G{' + this.contentDiv[i].parameterValue + '}';
        }

        if (this.contentDiv[i].parameterType == 'Function') {//isKeyValueFunction//isKeyValueFunction
          //console.log(this.contentDiv[i]['methodname']);
          if (this.keyValueFunctions.includes(this.contentDiv[i]['methodname']) || this.contentDiv[i]['isKeyValueFunction']) {
            let result = [];
            var warningMessage = '';
            this.contentDiv[i]['fieldlist'].forEach(data => {
              //console.log(data);

              if (data.isEditable == false && data.value == undefined) {
                data.value = data.defaultValues[0];
              }
              if (data.isMandatory == true) {
                // if(this.selectedSubfunction && data.isMandatory==true && data.isFieldDecideable==true){
                //   data.value = this.selectedSubfunction
                // }
                if (data.value == undefined || data.value == '') {
                  warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                }

              }
              if (data.isMandatory == false) {
                if (data.value == undefined || data.value == '') {
                  data.value = ' ';
                  //console.log(data);

                }

              }


              let result1 = data.name + "=" + data.value;
              result.push(result1);



            });

            if (warningMessage && warningMessage.length > 0) {
              // warningMessage = $scope.toCamelCase(warningMessage);
              this.toastrService.clear();
              this.toastrService.warning(warningMessage, null, {
                enableHtml: true
              });
              return;
            }
            let finalValue = result.join();
            paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //console.log(paramName);
            if (this.contentDiv[i]['result4']) {
              //console.log(this.contentDiv[i]['result4']);
              let varResult = []
              for (let j = 0; j < this.contentDiv[i]['result4'].length; j++) {
                this.contentDiv[i]['result4'][j].forEach(data1 => {

                  let varResult1 = data1.value;

                  varResult.push(varResult1);

                });
              }

              //console.log(varResult);

              let finaleValueOfVarFunc = varResult.join(',');

              //console.log(finaleValueOfVarFunc);

              //console.log('final',finaleValueOfVarFunc);


              paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ',' + finaleValueOfVarFunc + ')}';
            }
          }
          else {
            let result = [];
            var warningMessage = '';
            this.contentDiv[i]['fieldlist'].forEach(data => {
              //console.log(data);

              if (data.isEditable == false && data.value == undefined) {
                data.value = data.defaultValues[0];
              }

              if (data.isMandatory == true) {
                if (data.value == undefined || data.value == '') {
                  warningMessage = warningMessage + data.name + " cannot be empty <br/> ";
                }

              }
              if (data.isMandatory == false || data.value == '') {
                if (data.value == undefined) {
                  data.value = ' ';
                  //console.log(data);

                }

              }

              let result1 = data.value;
              result.push(result1);

            });
            if (warningMessage && warningMessage.length > 0) {
              // warningMessage = $scope.toCamelCase(warningMessage);
              this.toastrService.clear();
              this.toastrService.warning(warningMessage, null, {
                enableHtml: true
              });
              return;
            }
            let finalValue = result.join();
            paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
            //console.log(paramName);
            if (this.contentDiv[i]['result4']) {
              //console.log(this.contentDiv[i]['result4'][i]);
              let varResult = []
              for (let j = 0; j < this.contentDiv[i]['result4'].length; j++) {
                this.contentDiv[i]['result4'][j].forEach(data1 => {
                  if (data1.value != undefined) {
                    let varResult1 = data1.value;
                    varResult.push(varResult1);
                  }
                });
              }
              let finaleValueOfVarFunc = varResult.join(',');
              console.log('final', finaleValueOfVarFunc);


              paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ',' + finaleValueOfVarFunc + ')}';
            }
          }


          // //console.log(this.contentDiv[i]['parameterArg']);
          // if (this.contentDiv[i]['parameterArg']) {
          //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
          //   //console.log('result1', this.contentDiv[i]['result1']);

          //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
          //   }

          // }
          // else {
          //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   //console.log('result1', this.contentDiv[i]['result1']);
          //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
          //   }
          // }

          // if (this.contentDiv[i]['isKeyValueFunction']) {
          //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
          //     this.contentDiv[i]['result2'].forEach((value, index2) => {
          //       //console.log(index1, index2)
          //       if (index1 == index2) {
          //         let obj = { 'name': element, 'value': value }
          //         if(!this.contentDiv[i]['result3'])
          //         {
          //           this.contentDiv[i]['result3'] = [];
          //           this.contentDiv[i]['result3'].push(obj);
          //         }
          //         this.contentDiv[i]['result3'].push(obj);
          //       }
          //     });
          //   });

          //   let result = [];
          //   this.contentDiv[i]['result3'].forEach(data => {
          //     let result1 = data.name + "=" + data.value;
          //     result.push(result1);
          //   });

          // let finalValue = result.join();
          // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
          // //console.log(paramName);



          // else {

          // //console.log(this.contentDiv[i].parameterValue);

          //   let result = [];
          //   this.contentDiv[i]['fieldlist'].forEach(data => {
          //     let result1 = data.value;
          //     result.push(result1);
          //   });
          //   let finalValue = result.join();
          //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
          //     //console.log(paramName);

          //   // //console.log(this.contentDiv[i]['parameterArg']);
          //   // if (this.contentDiv[i]['parameterArg']) {
          //   //   var methodArgs = this.contentDiv[i]['parameterArg'].substr((this.contentDiv[i]['parameterArg'].indexOf(':') + 1), this.contentDiv[i]['parameterArg'].length);
          //   //   //console.log('result1', this.contentDiv[i]['result1']);

          //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //   //     paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + methodArgs + ',' + finalResult + ')}';
          //   //   }

          //   // }
          //   // else {
          //   //   var finalResult = this.contentDiv[i]['result1'].concat(this.contentDiv[i]['result2']).join();
          //   //   //console.log('result1', this.contentDiv[i]['result1']);
          //   //   if (!this.contentDiv[i]['isKeyValueFunction']) {
          //   //   paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalResult + ')}';
          //   //   }
          //   // }

          //   // if (this.contentDiv[i]['isKeyValueFunction']) {
          //   //   this.contentDiv[i]['Vfield'].forEach((element, index1) => {
          //   //     this.contentDiv[i]['result2'].forEach((value, index2) => {
          //   //       //console.log(index1, index2)
          //   //       if (index1 == index2) {
          //   //         let obj = { 'name': element, 'value': value }
          //   //         if(!this.contentDiv[i]['result3'])
          //   //         {
          //   //           this.contentDiv[i]['result3'] = [];
          //   //           this.contentDiv[i]['result3'].push(obj);
          //   //         }
          //   //         this.contentDiv[i]['result3'].push(obj);
          //   //       }
          //   //     });
          //   //   });

          //   //   let result = [];
          //   //   this.contentDiv[i]['result3'].forEach(data => {
          //   //     let result1 = data.name + "=" + data.value;
          //   //     result.push(result1);
          //   //   });

          //     // let finalValue = result.join();
          //     // paramName = paramName + '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue + ')}';
          //     // //console.log(paramName);
          //     if(this.contentDiv[i]['result4']){
          //     //console.log(this.contentDiv[i]['result4'][i]);
          //     let varResult = []
          //     this.contentDiv[i]['result4'][i].forEach(data1 => {

          //       let varResult1 = data1.name + "=" + data1.value;
          //       varResult.push(varResult1);
          //     });
          //     let finaleValueOfVarFunc = varResult.join();
          //     //console.log('final',finaleValueOfVarFunc);


          //       paramName = '${__' + this.contentDiv[i]['methodname'] + '(' + finalValue +','+ finaleValueOfVarFunc + ')}';
          //   }


          // }

          // }

        }




      }


      // //console.log("final result3");


      if (this.contentDiv[0]['parameterType'] != undefined) {
        //console.log(this.contentDiv);

        this.testStepAtSelectedIndex.parameters['settingValue'] = paramName;
      }

      //console.log('param', paramName);

    }

    this.testStepAtSelectedIndex.elementKey = this.arr.Element;

    this.testStepdata.teststepList[this.stepIndexTobeEdit] = this.testStepAtSelectedIndex
    this.testStepdata.teststepList.forEach(function (v) {
      if (v.parentNestedBlock) {
        delete v.parentNestedBlock
      }
    });
    this.updateTestStepByIndex();
  }
  updateTestStepByIndex() {
    const updateTestStepData = this.testStepdata;
    //console.log(updateTestStepData);
    const myObject = updateTestStepData;
    var myFinalObject = _.pick(myObject, ['title', 'id', 'comment', 'testCaseId', 'testDataSourceName', 'teststepList',]);
    this.http.post<any>(this.url + '/HuLoopRest/huloop/' + 'test/editTestCase/' + this.projectId + "/" + this.testId + '/false', myFinalObject).
      subscribe((data) => {
        if (data) {
          console.log("upDateData", data);
          this.testStep = data.teststepList
          for (let i = 0; i < this.testStep.length; i++) {
            // this.testStep[i] = {
            //    stepIndex:''
            //   }
            this.testStep[i].stepIndex = i;
            this.testStep[i].viewS = true;

          }
          this.visibleIndexForCardTip = this.testStep.length
          this.loadFlowchart(this.testStep);
          this.toastrService.clear();
          this.toastrService.success('Edited successFully')

        }
      });
  }
  onChangeFunctionDropdown(value, name, isFieldDecideable, index, defaultValues?: any) {
    //console.log('insideDropDown');
    console.log('defaultValues', defaultValues, value, name, isFieldDecideable);
    // if(defaultValues){
    //   var description = defaultValues.filter((f) => f.name ===value);
    //   console.log('description',description[0].description);
    //   this.functionDescription = description[0].description;
    // }else{
    //   this.functionDescription = ''
    // }

    // this.testStepAtSelectedIndex['functionDescription'] = this.functionDescription;

    //TODO: need to change this hack
    if (!isFieldDecideable) {
      return;
    }
    if (name === 'overwrite' && this.currentFunction.name === 'FILEHANDLER') {
      return;
    }
    if (name === 'track' && this.currentFunction.name === 'FILEHANDLER') {
      return;
    }


    // this.currentFunction.fieldList = this.contentDiv[index]['fieldlist'];
    var matchingElements = this.getMatchingFields(JSON.parse(JSON.stringify(this.currentFunction.fieldList)), name);
    //var matchingElements = this.currentFunction.fieldList.filter(o => o.visibleFieldName === name);
    var matchingValues = [];
    if (matchingElements.length > 0) {
      matchingValues = this.getMatchingValues(matchingElements, value);
      console.log(matchingValues);

      matchingValues.splice(0, 0, this.getFuntionField1(this.currentFunction.fieldList, name));// Add the current field at index 0
      this.contentDiv[index]['fieldlist'] = matchingValues;
      //console.log(this.contentDiv[index]['fieldlist']);
      JSON.parse(JSON.stringify(this.currentFunction.fieldList))
      // if ($scope.testStepObj.parametersForms) {
      //     $scope.testStepObj.parametersForms[0].args = new Array();
      //     $scope.testStepObj.parametersForms[0].args.push(value);
      // }
      // $scope.onSelectionChanges($scope.testStepObj);
    }
    if (this.currentFunction.type === 'variable' && this.currentFunction.variableFieldList && this.currentFunction.variableFieldList.length > 0) {
      // this.currentFunction.variableFieldList = angular.copy($scope.originalVaribaleFieldList);
      var matchingElements = [];
      for (var i = 0; i < this.currentFunction.variableFieldList.length; i++) {
        if (this.currentFunction.variableFieldList[i].visibleFieldName === name) {
          if (this.currentFunction.variableFieldList[i].visibleFieldValues.includes(value)) {
            this.currentFunction.variableFieldList[i].isVisible = true;
            matchingElements.push(this.currentFunction.variableFieldList[i]);
          }
        }
      }
      this.currentFunction.variableFieldList = matchingElements;
    }

  };
  getMatchingFields(fieldList, fieldName) {
    var matchingElements = [];
    for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].visibleFieldName === fieldName) {
        matchingElements.push(fieldList[i]);
      }
    }
    return matchingElements;
  }

  getMatchingValues(matchingElements, value) {
    var matchingValues = [];
    for (var i = 0; i < matchingElements.length; i++) {
      if (matchingElements[i].visibleFieldValues.includes(value)) {
        matchingElements[i].isVisible = true;
        matchingValues.push(matchingElements[i]);
      }
    }
    return matchingValues;
  }

  getFuntionField1(fieldList, fieldName) {
    var matchingField;
    for (var i = 0; i < fieldList.length; i++) {
      if (fieldList[i].name === fieldName) {
        matchingField = fieldList[i];
        break;
      }
    }
    return matchingField;

  }

  checkIfFunctionMethodNameExist(methodName) {
    //   var functionMethodNames = {}
    //   for (var i = 0; i < this.functions.length; i++) {
    //     // if(typeof(data.list[i]) == 'string' && JSON.parse(data.list[i])){
    //     var obj = JSON.parse(this.functions[i]);
    //     //console.log("objcheck", obj);
    //    functionMethodNames[obj.method] = obj.method;
    //   // }
    // }
    //   if (functionMethodNames[methodName]) {
    //       return true;
    //   }
    //   return false;
    var isExist = this.functions.find((f) => f.method == methodName);
    if (isExist) {
      return true
    }
    return false;
  }

  onCreateScreen() {
    if (this.editLocatorTitleForm.invalid) {
      return;
    }
    var objFormval = this.editLocatorTitleForm.value;
    console
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    var Objval = {
      name: objFormval.name,
      projectId: this.projectId
    }

    this.project.addScreen(Objval).subscribe((data) => {
      if (data) {
        this.locatorManagementCheck = false;
        this.getLocator();
        this.toastrService.clear();
        this.toastrService.success(' New screen added successfully');
        this.project.sendLocatorData(this.projectId);

      }

    });

  }

  changeTab(isElementKey: boolean, screenName: string) {
    this.editLocatorTitleForm.reset();
    if (isElementKey) {
      this.editLocatorTitleForm.patchValue({ name: screenName })
    }
  }

  // selectChangeScreen(event: any) {
  //   this.selectedScreen = event;
  //   // this.selectedScreen.substring(3);
  //   this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen); //imp
  //   this.locatorId = this.elementKeyData[0].id;
  //   this.project.getProjectById(this.projectId).subscribe((
  //     data => {
  //       this.projectData = data;
  //       this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
  //         (data) => {
  //           this.locatorValueData = data;
  //           this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
  //           this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
  //         }
  //       )
  //     }
  //   ))
  //   this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
  // }
  selectChangeScreen(event: any) {

    // //console.log("event : ",event);
    // //console.log(event.target.value);
    // //console.log(this.testStep);
    // //console.log(this.locatorData);
    this.selectedScreen = event;


    // this.selectedScreen.substring(3);
    // //console.log('selectedScreen',this.selectedScreen);
    // this.getLocator();
    this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen); //imp

    //console.log('elementKeyData', this.elementKeyData, this.selectedScreen)

    this.locatorId = this.elementKeyData[0].id;
    //console.log(this.locatorId);

    // new api
    if(!JSON.parse(localStorage.getItem('projectDataById'))){
      
    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        //console.log(this.projectData);
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            // this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
            //   //console.log(data);
            // })
            this.locatorValueData = data;
            // console.log(this.locatorValueData);
            if(this.locatorValueData.locatorEntryMap==null){
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
            if(this.locatorValueData.locatorEntryMap!=null){
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            //console.log(this.locatorEntryMapValue);
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
          }
        )
      }
    ))
    }
    else if(JSON.parse(localStorage.getItem('projectDataById'))){
      
      var res = JSON.parse(localStorage.getItem('projectDataById'));
          this.projectData = res;
          //console.log(this.projectData);
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              // this.subscription = this.project.getLocatorDataFromTestStep().subscribe((data) => {
              //   //console.log(data);
              // })
              this.locatorValueData = data;
              console.log(this.locatorValueData);
              if(this.locatorValueData.locatorEntryMap==null){
                this.locatorValueData.locatorEntryMap = {entry:[]};
                this.locatorValueData.locatorCommentMap = {entry:[]};
                // this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              }
              if(this.locatorValueData.locatorEntryMap!=null){
                this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
                this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
              }
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              //console.log(this.locatorEntryMapValue);
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
            }
          )
      
      }
    // this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
    //console.log(this.elementEntryKeyData);
  }

  delLocator(values) {
    this.confirmationDialogService.openConfirmDialog('Are you sure to delete ' + values + ' ?')
      .afterClosed().subscribe(res => {
        if (res) {
          const valueForDelete = this.locatorEntryMapValue.filter((f) => f.key == values);

          this.locatorEntryMapValue.forEach((element, index) => {
            if (element == valueForDelete[0]) this.locatorEntryMapValue.splice(index, 1);
          });
          var functionValue = _.omit(this.locatorValueData, ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
          this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
            (data: any) => {
              var d = data['locatorSuite'][0].name;
              this.testCase.getLocatorSuite(this.projectId).subscribe(
                (element) => {
                  this.locatorData = element['locatorSuite'];
                  this.loadElements(d);
                }
              )
              this.toastrService.clear();
              this.toastrService.success(' locator deleted successfully');
              this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
                (data) => {
                  this.locatorValueData = data;
                  this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
                  this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
                  this.addLocatorsForm.reset();
                }
              )
            }
          )
        }
      })
  }

  insertLocatorComment(key) {
    this.keyForinsertComment = key;
    if (this.locatorEntryCommentValue == undefined) {
      this.valueForUpdate1 = 'Enter Comment';
      return;
    }
    this.valueForInsert = this.locatorEntryCommentValue.filter((f) => f.key == this.keyForinsertComment);
    this.valueForUpdate1 = this.valueForInsert[0] ? this.valueForInsert[0].value : undefined;
    if (this.valueForUpdate1 == undefined) {
      this.valueForUpdate1 = 'Enter Comment'
    }
    if (this.valueForUpdate1 == "") {
      this.valueForUpdate1 = 'Enter Comment'
    }
  }
  updateLocator(index, rowData) {
    console.log(rowData);
    this.locatorValueIndex = index;
    this.updateLocatorsForm.patchValue({ 'key': rowData.key, 'value': rowData.value, 'comment': this.valueForUpdate1 });
  }

  onAddLocators() {

    if (this.addLocatorsForm.invalid) {
      return;
    }

    var objFormval1 = this.addLocatorsForm.value;
    if (this.locatorEntryMapValue) {

      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      const objForCommentMap =
      {
        key: objFormval1.key,
        value: objFormval1.comment
      }

      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Values Are Not Allowed ');
        return;
      }
      const compareKeyValue = this.locatorValueData.locatorEntryMap.entry.filter((f) => f.key == objForCommentMap.key);
      if (compareKeyValue[0]) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
        return;
      }
      this.locatorEntryMapValue.unshift(objFormval1);
      if (this.locatorValueData.locatorCommentMap) {
        this.locatorValueData.locatorCommentMap.entry.unshift(objForCommentMap);
      }
      else {
        let data =
        {
          entry: []
        }
        data.entry.push(objForCommentMap);
        this.locatorValueData.locatorCommentMap = data;
      }
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data: any) => {
          var d = data['locatorSuite'][0].name;
          this.testCase.getLocatorSuite(this.projectId).subscribe(
            (element) => {
              this.locatorData = element['locatorSuite'];
              this.loadElements(d);
            }
          )
          this.getLocator();
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          this.cancelAddLocator.nativeElement.click();
          this.initForms();
        }
      )
    }
    else {

      if (objFormval1.key == null || objFormval1.value == null) {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys/values Are Not Allowed');
        return;
      }
      if (objFormval1.key == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty keys Are Not Allowed ');
        //console.log('Empty key Are Not Allowed');
        return;
      }
      if (objFormval1.value == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Value Are Not Allowed ');
        //console.log('Empty Value Are Not Allowed');

        return;
      }
      if (objFormval1.comment == '') {
        this.toastrService.clear();
        this.toastrService.warning('Sorry ! Empty Comment Are Not Allowed ');
        //console.log('Empty comment Are Not Allowed');
        return;
      }
      this.locatorEntryMapValue = { entry: [] };
      this.locatorValueData.locatorCommentMap = {
        entry: [
          {
            key: objFormval1.key,
            value: objFormval1.comment
          }
        ]
      }
      this.locatorEntryMapValue.entry.unshift(objFormval1);
      this.locatorValueData.locatorEntryMap = this.locatorEntryMapValue;
      this.setting.editLocatorSuite(this.projectId, this.locatorValueData).subscribe(
        (data: any) => {
          this.toastrService.clear();
          this.toastrService.success(' Locator added successfully');
          var d = data.name;
          this.testCase.getLocatorSuite(this.projectId).subscribe(
            (element) => {
              this.locatorData = element['locatorSuite'];
              this.loadElements(d);
            }
          )
          this.cancelAddLocator.nativeElement.click();
          this.initForms();
          this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
            (data) => {
              this.locatorValueData = data;
              this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
              this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
              this.getLocator();
            }
          )
        }
      )
    }

  }

  loadElements(data) {
    this.selectedScreen = data
    // this.selectedScreen.substring(3);
    this.elementKeyData = this.locatorData.filter((s) => s.name === this.selectedScreen);

    this.locatorId = this.elementKeyData[0].id;

    this.project.getProjectById(this.projectId).subscribe((
      data => {
        this.projectData = data;
        this.setting.getLocatorValue(this.projectId, this.locatorId).subscribe(
          (data) => {
            this.locatorValueData = data;
            this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
            this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
          }
        )
      }
    ))

    this.elementEntryKeyData = this.elementKeyData[0].locatorEntryMap.entry;
  }

  submitUpdateLocatorForm() {
    if (this.updateLocatorsForm.invalid) {
      return;
    }
    var objFormval = this.updateLocatorsForm.value;
    let screenNameData = this.locatorData.filter((data) => data.name == this.selectedScreen)
    screenNameData[0].locatorEntryMap.entry[this.locatorValueIndex] = objFormval;
    screenNameData[0].locatorCommentMap = {
      entry: [
        {
          key: objFormval.key,
          value: objFormval.comment
        }
      ]
    }
    var functionValue = _.omit(screenNameData[0], ['alternateLocatorMap', 'coordinateMap', 'locatorEntryMapEdited', 'path']);
    
    const compareKeyValue = functionValue.locatorEntryMap.entry.filter((f) => f.key == objFormval.key);

    if (compareKeyValue[1]) {
      this.toastrService.clear();
      this.toastrService.warning('Sorry ! Duplicate keys Are Not Allowed ');
      return;
    }

    this.setting.editLocatorSuite(this.projectId, functionValue).subscribe(
      (data) => {
        this.locatorValueData = data['locatorSuite'][0];
        this.locatorEntryMapValue = this.locatorValueData.locatorEntryMap.entry;
        this.locatorEntryCommentValue = this.locatorValueData.locatorCommentMap.entry;
        var d = data['locatorSuite'][0].name;
        this.loadElements(d);
        this.toastrService.clear();
        this.toastrService.success('Locator data updated successfully');
        this.initForms();
        this.cancelUpdateLocator.nativeElement.click();
      })
  }
  nestedBlock(commandName, i) {
    if (commandName == 'IF') {
      return true;
    }
    else {
      return false;
    }
  }

  findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }
  getAllIndexes(arr, val) {
    var indexes = [], i;
    for (i = 0; i < arr.length; i++)
      if (arr[i].commandName === val)
        indexes.push(i);
    return indexes;
  }

  ifBlockNested = [];
  flatten(arr) {
    return arr.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) ? this.flatten(toFlatten) : toFlatten);
    }, []);
  }
  checkIfBlock(steps) {


    // this.findWithAttr(steps, 'commandName', 'IF');
    var getAllIfIndex = this.getAllIndexes(steps, 'IF');

    var getAllEndIndex = this.getAllIndexes(steps, 'ENDIF');
    var firstIfIndex = this.findWithAttr(steps, 'commandName', 'IF');
    var firstEndIndex = this.findWithAttr(steps, 'commandName', 'ENDIF');
   
    //  if (getAllIfIndex.length==1 && getAllEndIndex.length==1) {
    //   var IfBlock = steps.slice(firstIfIndex, firstEndIndex+1);
    //   console.log('testIf',IfBlock);
    //   IfBlock.forEach((nestedCommand,i) => {
    //     if(nestedCommand.commandName=='ELSEIF' || nestedCommand.commandName=='ELSE' ){

    //     }
    //   });
    //  }
    //  else{
      if(getAllIfIndex.length>0 && getAllEndIndex.length>0){
        var nestedBlock = this.extractSubset(steps);
        this.testCopyFlowChart = nestedBlock;
      }
    else{
      this.testCopyFlowChart = steps
    }
    console.log('subSet1', this.testCopyFlowChart) 
    this.getIncludedTestCases();
   
     console.log('subSet1', this.testCopyFlowChart)
    //   var IfCount = 0;
    //   var endIfCount=0;
    //   var ifBlock =[];
    //   while (this.endIndex < steps.length) {
    //     var new_arr = steps.slice(this.endIndex,steps.length)
    //     var ifIndex = new_arr.findIndex((f)=>f.commandName=='IF');
    //     if(ifIndex != -1){
    //       nestedBlock.push(...this.extractSubset(new_arr))
    //     }
    //   }
    //   // var ifIndex = steps.findIndex((f)=>f.commandName=='IF');
    //   //arr.splice(2, 0, "Lene");
    //   var new_arr = steps.slice(this.endIndex,steps.length)
    //   var ifIndex = new_arr.findIndex((f)=>f.commandName=='IF');
    //   // steps.splice(ifIndex,0,nestedBlock);
    //   console.log('newArray',new_arr);
    //   if(ifIndex != -1){
    //     nestedBlock.push(...this.extractSubset(new_arr))
    //   }
    // console.log(nestedBlock);
    // this.testCopyFlowChart = nestedBlock;
    // var ifIndex = steps.findIndex((f)=>f.commandName=='IF');
    // var EndIfIndex = steps.findLastIndex((f)=>f.commandName=='ENDIF');

    // if (ifIndex && EndIfIndex) {
    //   // var IfBlock = steps.slice(ifIndex+1, EndIfIndex+1);
    //   // ifBlock.forEach((element,i) => {
    //   //   if(element.commandName=='IF'){
    //   //     ifIndex = i;
    //   //   }
    //   //   if(element.commandName=='ENDIF'){
    //   //     EndIfIndex = i;
    //   //   }
    //   // });
    //   var IfBlock = steps.slice(ifIndex, EndIfIndex+1);
    //   console.log('IfIndex',ifIndex,EndIfIndex,'allIfBlock',IfBlock);
    //   // this.testCopyFlowChart.splice(ifConditionIndex, endIfIndex - ifConditionIndex);
    // }
    // else{
    //   return;
    // }
    // this.testCopyFlowChart.slice(ifConditionIndex, endIfIndex);


    // steps.forEach(element => {
    //   if(element.commandName=='IF'){
    //     ++IfCount;
    //   }
    //   if(element.commandName=='ENDIF'){
    //     ++endIfCount;
    //   }
    // });

    //  }

  }

  extractSubset(array) {
    let subset = [];
    const nestedArray: any = [];
    let ifFound = false;
    let IfCount = 0;
    let endIfCount = 0;
    var index = 0;
    var FinalArray = [];
    var childIndex ;
    var childEnable = false;
    for (const item of array) {
      ++index
      if (item.commandName === 'IF' ) {
        ifFound = true;
        ++IfCount;
        subset.push(item);
       
      }
       else if (item.commandName === 'ENDIF') {

        ++endIfCount
        ifFound = false;
        this.endIndex = index
        subset.push(item);
        // if(endIfCount>1){
        //   subset.forEach(
        //    (child,i)=>{
            
        //      if(child.commandName=='ENDIF'){
        //       subset.pop();
        //       subset[childIndex-1].children.push(item);
        //      }
        //    }
        //   )
        //   if(childIndex){
        //    childEnable = false
        //   //  subset.pop();
        //   //  subset[childIndex-1].children=[];
           
        //   }
          
        //  }
        if (IfCount == endIfCount) {
          childEnable=false;
          break;
          // nestedArray.push(item);
        }

      }
      // else if(childEnable){
      //   // subset[childIndex-1].children=[];
      //   subset[childIndex-1].children.push(item);
      // }
      else if (ifFound) {
        subset.push(item);
      }
      else if (!ifFound && item != undefined) {

        nestedArray.push(item);
      }

    }
    if(nestedArray.length>0){
    nestedArray[nestedArray.length - 1].parentNestedBlock = [];
    nestedArray[nestedArray.length - 1].parentNestedBlock.push(subset)
    var remainingArray = array.slice(this.endIndex, array.length);
    //  var ifExist = array.findIndex((f)=>f.commandName=='IF')
    // if(ifExist != -1){
    FinalArray.push(...nestedArray);
    if (remainingArray.length > 0) {
      FinalArray.push(...this.extractSubset(remainingArray));
    }
  }
    // }

     console.log('final',FinalArray);
     
    return FinalArray;
  }
findNested(subset){
  var childIndex;
  var childEnable = false;
  var count=0
const subset1 = [];
    subset.forEach(
     (child,i)=>{
      if(i==0){
        subset1.push(child);
        // subset.splice(i,1)
       }
      if(i>0){
       if(child.commandName=='IF' || child.commandName=='ELSEIF'||child.commandName=='ELSE'){
         childIndex = i;
         childEnable = true
        // subset.pop();
        if(subset1[subset1.length-1]){
          // ++count;
          // if(count>1){
            subset1.push(child);
          // }
          subset1[subset1.length-1].children=[];
          subset1[subset1.length-1].children.push(child);
        }
      
        // else{
        //  console.log('subsetCheck', subset.slice(childIndex,subset.length));
        //  subset1.push(child);
        // }
       
        // subset.splice(i,1)
       }
      //  if(childIndex>){
      //   childEnable = true
      //   subset.pop();
      //   subset[childIndex].children=[];
      //   subset[childIndex].children.push(child);
      //  }
       if(childEnable && i!==childIndex && subset1[subset1.length-1]){
        subset1[subset1.length-1].children.push(child);
        // subset.splice(i,1)
       }
       if(!childEnable){
        subset1.push(child);
        // subset.splice(i,1)
       }
      //  if(subset[subset.length-1].commandName !== 'ENDIF'){
      //   subset1.push(child);
      //   // subset.splice(i,1)
      //  }
       if(child.commandName=='ENDIF' && childEnable && subset1[subset1.length-1] && subset[subset.length-1].commandName !== 'ENDIF'){
        subset1[subset1.length-1].children.push(child);
        childEnable = false;
        // subset.splice(i,1)

        
      }
     }
    
    }
    
    )
    
    // } 
    return subset1;
}

  // convertArray(inputArray) {
  //   let outputArray = [];
  //   let currentParent:any = null;
  //   let currentChildren:any = null;

  //   for (let i = 0; i < inputArray.length; i++) {
  //     const currentItem = inputArray[i];

  //     if (currentItem.commandName === "OPENBROWSER" && currentParent === null) {
  //       // If it's the first occurrence of "OPENBROWSER", create a new object
  //       outputArray.push({ ...currentItem, parentNestedBlock: [] });
  //       currentParent = outputArray[outputArray.length - 1];
  //       currentChildren = currentParent.parentNestedBlock;
  //     } else if (
  //       (currentItem.commandName === "IF" || currentItem.commandName === "ELSEIF") &&
  //       currentParent !== null
  //     ) {
  //       // If it's an "IF" or "ELSEIF" within a "OPENBROWSER" block, create a new object
  //       currentChildren.push({ ...currentItem, children: [] });
  //       currentParent = currentChildren[currentChildren.length - 1];
  //       currentChildren = currentParent.children;
  //     } else if (currentItem.commandName === "ENDIF" && currentParent !== null) {
  //       // If it's an "ENDIF" within a "OPENBROWSER" block, reset the current parent
  //       currentParent = [];
  //       currentChildren = [];
  //     } else {
  //       // If it's any other command, add it to the current parent's children
  //       currentChildren.push(currentItem);
  //     }
  //   }

  //   return outputArray;
  // }


  enableLongArrow(testStep){
    if(testStep){
      this.LongArrow = true;
    }
    else{
      this.LongArrow = false;
    }
  }
  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  downloadImage(){
    this.spinnerService.isLoading.next(true);
    html2canvas(this.screen.nativeElement).then(canvas => {
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
      this.downloadLink.nativeElement.download = 'Process-flow-diagram.png';
      this.downloadLink.nativeElement.click();
      this.spinnerService.isLoading.next(false);
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    console.log(event);
    // let this.checkedIndex=undefined;
    // var shiftEnable = true;
  //   if(event.shiftKey && event.key.includes('Arrow')){
  //   this.testCopyFlowChart.forEach((element,i) => {
  //     if (element.checked == true) 
  //     {
  //       this.checkedIndex = i;
  //     }
  //     if(element.parentNestedBlock){
  //       element.parentNestedBlock[0].forEach((nestedElement,j )=> {
  //         if (nestedElement.checked == true) {
  //           this.checkedIndex = j
  //         }
         
  //       });
  //     }
  //   });
  // } this.testStepCopy
    if (event.shiftKey && event.key.includes('Arrow') && this.checkedIndex==0 || this.checkedIndex > 0 && this.cardView) {
      
      console.log('Shift key and arrow key pressed');
      switch (event.key) {
        case 'ArrowUp':
          console.log('Arrow Up pressed',);
          this.checkedIndex=this.checkedIndex-1
          if(this.testCopyFlowChart[this.checkedIndex].checked==undefined || this.testCopyFlowChart[this.checkedIndex].checked==false){
            this.onChange(this.checkedIndex,true)
            // this.checkedIndex -= 1
            return;
          }
          else {
            this.onChange(this.checkedIndex,false)
            // this.checkedIndex -= 1

          }
          // this.onChange(--this.checkedIndex,false)
          break;
        case 'ArrowDown':
          this.checkedIndex=this.checkedIndex+1
          if(this.testCopyFlowChart[this.checkedIndex].checked==undefined || this.testCopyFlowChart[this.checkedIndex].checked==false){
            this.onChange(this.checkedIndex,true)
            // this.checkedIndex++
            return;
          }
          else{
            this.onChange(this.checkedIndex,false)
          }
          console.log('Arrow Down pressed',);
          break;
        case 'ArrowLeft':
          console.log('Arrow Left pressed');
          break;
        case 'ArrowRight':
          console.log('Arrow Right pressed');
          break;
        default:
          break;
      }
    }
    if (event.shiftKey && event.key.includes('Arrow') && this.checkedIndex==0 || this.checkedIndex > 0 && !this.cardView) {
      
      console.log('Shift key and arrow key pressed');
      switch (event.key) {
        case 'ArrowUp':
          console.log('Arrow Up pressed',);
          this.checkedIndex=this.checkedIndex-1
          if(this.testStepCopy[this.checkedIndex].checked==undefined || this.testStepCopy[this.checkedIndex].checked==false){
            this.onChange(this.checkedIndex,true)
            // this.checkedIndex -= 1
            return;
          }
          else {
            this.onChange(this.checkedIndex,false)
            // this.checkedIndex -= 1

          }
          // this.onChange(--this.checkedIndex,false)
          break;
        case 'ArrowDown':
          this.checkedIndex=this.checkedIndex+1
          if(this.testStepCopy[this.checkedIndex].checked==undefined || this.testStepCopy[this.checkedIndex].checked==false){
            this.onChange(this.checkedIndex,true)
            // this.checkedIndex++
            return;
          }
          else{
            this.onChange(this.checkedIndex,false)
          }
          console.log('Arrow Down pressed',);
          break;
        case 'ArrowLeft':
          console.log('Arrow Left pressed');
          break;
        case 'ArrowRight':
          console.log('Arrow Right pressed');
          break;
        default:
          break;
      }
    }
  }



  ngOnDestroy() {
    //  this.projectSubscription.unsubscribe();
  }


  
}
